import React, { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import { Button, Card, Col, Container, Dropdown, DropdownButton, Form, Modal, Row, Table } from "react-bootstrap";
import { Tooltip } from 'react-tooltip';
import { PencilIcon } from '@primer/octicons-react';
import { BiCalendar, BiCheckSquare, BiXCircle, BiHelpCircle, BiPlus, BiRectangle, BiSearch, BiTrash } from "react-icons/bi";
import DateTimePicker from 'react-datetime-picker';
import DeleteConfirmDialog from './DeleteConfirmDialog';
import SoundPickerDialog from './SoundPickerDialog';
import { axiosAuth_DATA_MGMT_API } from '../utils/AxoisUtilComponent';
import { useTranslation } from 'react-i18next';
import classes from './AdminPages.module.css';
import { translateAPIError } from '../utils/apiUtils';
import { formatDate } from '../utils/timeUtils';
import { isNaturalNumber } from '../utils/jsUtils';
import configInfo from '../config/config.json';


const AlarmRuleAdminDetailsView = (props) => {

  // Utilities
  const { i18n, t } = useTranslation(['common', 'custom']);
  const navigate = useNavigate();

  // Initialize with actual JSON obj.  If not, will get UI error.
  const [objAttrs, setObjAttrs] = useState({
    id: '',
    code: '',
    description: '',
    class: '',
    type: '',
    datasourceId: '',
    extSysId: '',
    impactType: '',
    defaultLevel: '',
    broadcast: '',
    autoWorkorder: '',
    resumeTime: '',
    soundId: null,
    status: '',
    triggerLogic: {
      useOccCnt: false,
      useOccDur: false,
      occCnt: '',
      timeWindow: '',
      occDur: '',
      applTime: [],
      scope: 'SCOPE_DP_TYPE',
      condGrp1: {
        cond1: {},
        cond2: {},
        condOp1: ''
      },
      condGrp2: {
        cond3: {},
        cond4: {},
        condOp2: ''
      },
      condGrpOp: 'AND'
    },
    creatorUsername: '',
    timeCreated: '',
    updaterUsername: '',
    timeUpdated: ''
  });

  const [currentObjAttrs,          setCurrentObjAttrs]          = useState({});

  const [triggerLogicAttrs,        setTriggerLogicAttrs]        = useState({scope: 'SCOPE_DP_TYPE', condGrpOp: 'AND'});
  const [currentTriggerLogicAttrs, setCurrentTriggerLogicAttrs] = useState({});

  const [resumeTime,               setResumeTime]               = useState(null);

  const [showSoundPickerDialog,    setShowSoundPickerDialog]    = useState(false);


  const classOptions = [
    { key: "REALTIME",   value: "REALTIME" },
    { key: "PREDICTIVE", value: "PREDICTIVE" }
  ];

/*
  const typeOptions = [
    { key: "DIRECT",  value: "DIRECT" },
    { key: "DERIVED", value: "DERIVED" }
  ];
*/

  const impactTypeOptions = [
    { key: "LOCATION", value: "LOCATION" },
    { key: "ASSET",    value: "ASSET" },
    { key: "LIFT",     value: "LIFT" }
  ];

  const defaultLevelOptions = [
    { key: "LOW",      value: "LOW" },
    { key: "MEDIUM",   value: "MEDIUM" },
    { key: "HIGH",     value: "HIGH" },
    { key: "CRITICAL", value: "CRITICAL" }
  ];

  const statusOptions = [
    { key: "ACTIVE",    value: "ACTIVE" },
    { key: "SUSPENDED", value: "SUSPENDED" },
    { key: "DISABLED",  value: "DISABLED" }
  ];

  const opOptions = [
    { key: "EXISTS", value: t("custom:I18N_LogicalOp_EXISTS") },
    { key: "EQ",     value: t("custom:I18N_LogicalOp_EQ") },
    { key: "NE",     value: t("custom:I18N_LogicalOp_NE") },
    { key: "GT",     value: t("custom:I18N_LogicalOp_GT") },
    { key: "GE",     value: t("custom:I18N_LogicalOp_GE") },
    { key: "LT",     value: t("custom:I18N_LogicalOp_LT") },
    { key: "LE",     value: t("custom:I18N_LogicalOp_LE") }
  ];

  const andOrOptions = [
    { key: "None", value: "None" },
    { key: "AND",  value: t("custom:I18N_LogicalOp_AND") },
    { key: "OR",   value: t("custom:I18N_LogicalOp_OR") }
  ];

  const timeWinUnitOptions = [
    { key: 'm', value: 'm' },
    { key: 'h', value: 'h' },
    { key: 'd', value: 'd' }
  ];


  const [categoryList,                setCategoryList]                = useState(null);

  const [assocDpTypeList,             setAssocDpTypeList]             = useState('');
  const [assocDpList,                 setAssocDpList]                 = useState('');

  // DpType select stuff
  const [showDpTypeSelectDialog,      setShowDpTypeSelectDialog]      = useState(false);
  const [showFormulaDpTypeSelDialog,  setShowFormulaDpTypeSelDialog]  = useState(false);
  const [dpTypeSearchTerm,            setDpTypeSearchTerm]            = useState('');
  const [dpTypeList,                  setDpTypeList]                  = useState('');
  const [errMsg_DpTypeSelect,         setErrMsg_DpTypeSelect]         = useState('');
  const [errMsg_FormulaDpTypeSel,     setErrMsg_FormulaDpTypeSel]     = useState('');

  const [dpSelectMode,                setDpSelectMode]                = useState('');     // ASSOC_SELECT, FORMULA_SELECT
  const [showDpSelectDialog,          setShowDpSelectDialog]          = useState(false);
  const [showFormulaDpSelDialog,      setShowFormulaDpSelDialog]      = useState(false);
  const [dpSearchTerm,                setDpSearchTerm]                = useState('');
  const [dpList,                      setDpList]                      = useState('');
  const [errMsg_DpSelect,             setErrMsg_DpSelect]             = useState('');
  const [errMsg_FormulaDpSel,         setErrMsg_FormulaDpSel]         = useState('');

  // View vs Edit Modes
  const [editModeGeneral,             setEditModeGeneral]             = useState(false);
  const [editModeTriggerLogic,        setEditModeTriggerLogic]        = useState(false);

  const [errMsg,                      setErrMsg]                      = useState('');
  const [errMsg_UpdateGeneral,        setErrMsg_UpdateGeneral]        = useState('');
  const [errMsg_UpdateTriggerLogic,   setErrMsg_UpdateTriggerLogic]   = useState('');


  // Action Stuff
  const [actionList, setActionList] = useState([]);

  //const [showActionInfo, setShowActionInfo] = useState(false);
  //const [actionSelected, setActionSelected] = useState();

  const [actionAddList, setActionAddList] = useState([]);

  const [unassignedActionList, setUnassignedActionList] = useState();

  const [showAddActionDialog, setShowAddActionDialog] = useState(false);
  const [addActionErrMsg, setAddActionErrMsg] = useState('');


  // UI Functions

  // Initialize state
  useEffect(() => {

    if (props) {
      fetchCategories();

      fetchAssociatedDpTypes(props.objDetails.id);
      fetchAssociatedDps(props.objDetails.id);
      fetchAssociatedActions(props.objDetails.id);

      fetchObj(props.objDetails.id);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props]);


  const fetchObj = (id) => {

    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_DATA_MGMT_API.get("alarm-rules/" + id);

        resolve(res.data);

        if (res.status === 200) {

          setObjAttrs(res.data[0]);
          setCurrentObjAttrs(res.data[0]);

          preProcessAlarmRuleAttrs(res.data[0]);
        }
      } catch (error) {
        if (!error.message || (error.message !== 'IGNORE')) {
          setErrMsg(t(translateAPIError(error)));
        }
      }
    });
  }


  function preProcessAlarmRuleAttrs(alarmRuleDetails) {

    // Spin off Trigger Logic from general attr object
    if (!alarmRuleDetails.triggerLogic ||
        Object.keys(alarmRuleDetails.triggerLogic).length === 0) {

      setTriggerLogicAttrs({
        scope:        'SCOPE_DP_TYPE',
        condGrpOp:    'AND',
        applTime:     ['ANYTIME'],
        ANYTIME:      true,
        OFFICE_HR:    false,
        NONOFFICE_HR: false,
        BIZ_HR:       false,
        NONBIZ_HR:    false});

      setCurrentTriggerLogicAttrs({
        scope:        'SCOPE_DP_TYPE',
        condGrpOp:    'AND',
        applTime:     ['ANYTIME'],
        ANYTIME:      true,
        OFFICE_HR:    false,
        NONOFFICE_HR: false,
        BIZ_HR:       false,
        NONBIZ_HR:    false});
    } else {

      // Deep copy
      let tmpTriggerLogicAttrs =  JSON.parse (JSON.stringify(alarmRuleDetails.triggerLogic));

      // Amend old alarm rule trigger logic, that did not have the "scope" variable
      if (!tmpTriggerLogicAttrs.scope) {
        tmpTriggerLogicAttrs.scope = 'SCOPE_DP';
      }

      if (!tmpTriggerLogicAttrs.useOccCnt) {
        tmpTriggerLogicAttrs.useOccCnt = false;
      }
      if (!tmpTriggerLogicAttrs.useOccDur) {
        tmpTriggerLogicAttrs.useOccDur = false;
      }

      if (tmpTriggerLogicAttrs.applTime) {
        tmpTriggerLogicAttrs.ANYTIME      = tmpTriggerLogicAttrs.applTime.includes('ANYTIME');
        tmpTriggerLogicAttrs.OFFICE_HR    = tmpTriggerLogicAttrs.applTime.includes('OFFICE_HR');
        tmpTriggerLogicAttrs.NONOFFICE_HR = tmpTriggerLogicAttrs.applTime.includes('NONOFFICE_HR');
        tmpTriggerLogicAttrs.BIZ_HR       = tmpTriggerLogicAttrs.applTime.includes('BIZ_HR');
        tmpTriggerLogicAttrs.NONBIZ_HR    = tmpTriggerLogicAttrs.applTime.includes('NONBIZ_HR');
      }

      setTriggerLogicAttrs(tmpTriggerLogicAttrs);
      setCurrentTriggerLogicAttrs(tmpTriggerLogicAttrs);
    }

    // Spin off Date object typed variable for Resume Time
    if (alarmRuleDetails.resumeTime) {
      setResumeTime(new Date(alarmRuleDetails.resumeTime));
    }

    setCurrentObjAttrs(alarmRuleDetails);
    setObjAttrs(alarmRuleDetails);
  }


  const fetchCategories = () => {

    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_DATA_MGMT_API.get("alarm-categories");

        resolve(res.data);

        if (res.status === 200) {
          setCategoryList(res.data);
        }
      } catch (error) {
        setErrMsg(t(translateAPIError(error)));
      }
    });
  }

  const fetchAssociatedDpTypes = (alarmRuleId) => {

    if (!alarmRuleId) {
      return;
    }

    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_DATA_MGMT_API.get("alarm-rules/" + alarmRuleId + "/dp-types");

        resolve(res.data);

        if (res.status === 200) {
          setAssocDpTypeList(res.data);
        }

        setErrMsg('');
      } catch (error) {
        setErrMsg(t(translateAPIError(error)));
      }
    });
  }

  const fetchAssociatedDps = (alarmRuleId) => {

    if (!alarmRuleId) {
      return;
    }

    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_DATA_MGMT_API.get("alarm-rules/" + alarmRuleId + "/datapoints");

        resolve(res.data);

        if (res.status === 200) {
          setAssocDpList(res.data);
        }

        setErrMsg('');
      } catch (error) {
        setErrMsg(t(translateAPIError(error)));
      }
    });
  }


  const fetchAssociatedActions = (alarmRuleId) => {

    if (!alarmRuleId) {
      return;
    }

    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_DATA_MGMT_API.get("alarm-rules/" + alarmRuleId + "/actions");

        resolve(res.data);

        if (res.status === 200) {
          setActionList(res.data);
        }

        setErrMsg('');
      } catch (error) {
        if (!error.message || (error.message !== 'IGNORE')) {
          setErrMsg(t(translateAPIError(error)));
        }
      }
    });
  }


  const fetchUnassignedActions = () => {

    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_DATA_MGMT_API.get("actions");

        resolve(res.data);

        if (res.status === 200) {

          const cleanList = res.data;

          // Remove dpType types already assigned to the user
          let tempList = [];

          for (let i=0; i<actionList.length; i++) {
            tempList.push(actionList[i].name);
          }

          let unassignedList = [];
          for (let i=0; i<cleanList.length; i++) {
            if (!tempList.includes(cleanList[i].name)) {
              unassignedList.push(cleanList[i]);
            }
          }

          setUnassignedActionList(unassignedList);
        }

        setShowAddActionDialog(true);
        setErrMsg(''); //### NEED TO FIX
      } catch (error) {
        if (!error.message || (error.message !== 'IGNORE')) {
          setErrMsg(t(translateAPIError(error)));  //### NEED TO FIX
        }
      }
    });
  }


  // --- Edit General Attributes

  const handleEditGeneral = (e) => {
    e.preventDefault();
    setEditModeGeneral(true);
  }

  const onAttrsInputChange = (e) => {
    //setObjAttrsWithFormatting({ ...objAttrs, [e.target.name]: e.target.value })
    setObjAttrs({ ...objAttrs, [e.target.name]: e.target.value });
  }

  const onCategoryClick = (categoryId) => {
    setObjAttrs({ ...objAttrs, categoryId: categoryId })
  };

  const onClassSelect = (key, event) => {
    setObjAttrs({ ...objAttrs, class: key })
  };

/*
  const onTypeSelect = (key, event) => {
    setObjAttrs({ ...objAttrs, type: key })
  };
*/

  const onImpactTypeSelect = (key, event) => {
    setObjAttrs({ ...objAttrs, impactType: key })
  };

  const onDefaultLevelSelect = (key, event) => {
    setObjAttrs({ ...objAttrs, defaultLevel: key })
  };

  const onStatusSelect = (key, event) => {
    // Deep copy
    let tempAttrs = JSON.parse (JSON.stringify(objAttrs));

    tempAttrs.status = key;

    if (tempAttrs.status !== 'SUSPENDED') {
      tempAttrs.resumeTime = null;
      setResumeTime('');
    }

    setObjAttrs(tempAttrs);
  };

  const onCheckboxSelect = (e) => {
    setObjAttrs({ ...objAttrs, [e.target.name]: e.target.checked });
  }

  const onDatepickerChange = (value) => {
    let newTime = (new Date(value)).getTime();
    let currentTime = (new Date()).getTime();

    // ### This check is not necessary, since the UI already built guardrail.  But keep it here for now. ###
    if (!value && (value != null) && (newTime < currentTime)) {
      setErrMsg_UpdateGeneral(t("I18N_ERR_Date_must_be_future"));
    } else {
      setErrMsg_UpdateGeneral("");
      setObjAttrs({ ...objAttrs,
                          resumeTime: ((value !== null) && (value instanceof Date)) ? value.toISOString() : null})
      setResumeTime(value);
    }
  }

  const handleEditGeneralCancel = (e) => {
    e.preventDefault();

    // Reset fields
    setObjAttrs(currentObjAttrs);
    preProcessAlarmRuleAttrs(currentObjAttrs);

    setEditModeGeneral(false);
  }


  const handleEditGeneralSubmit = (e) => {
    e.preventDefault();

    if (!configInfo.uiConfig.visibleFields.ALARMRULE_Class) {
      // For customers who does not support different alarm classes, they are hardcoded to be REAL_TIME
      if (!objAttrs.class || (objAttrs.class == null) || (objAttrs.class.length === 0)) {
        objAttrs.class = 'REALTIME';
      }
    }

    if (!objAttrs.code || objAttrs.code.trim().length === 0) {
      setErrMsg_UpdateGeneral(t("I18N_ERR_Need_code"));
      return;
    } else if ((objAttrs.code != null) && (objAttrs.code.length > 50)) {
      setErrMsg_UpdateGeneral(t("I18N_ERR_Max_len_code") + 50);
      return;
    } else if (!objAttrs.description || objAttrs.description.trim().length === 0) {
      setErrMsg_UpdateGeneral(t("I18N_ERR_Need_description"));
      return;
    } else if ((objAttrs.description != null) && (objAttrs.description.length > 200)) {
      setErrMsg_UpdateGeneral(t("I18N_ERR_Max_len_desc") + 200);
      return;
    } else if (!objAttrs.categoryId || objAttrs.categoryId.length === 0) {
      setErrMsg_UpdateGeneral(t("I18N_ERR_Need_alarm_category"));
      return;
    } else if (!objAttrs.defaultLevel || objAttrs.defaultLevel.length === 0) {
      setErrMsg_UpdateGeneral(t("I18N_ERR_Need_alarm_default_level"));
      return;
    } else if (   configInfo.uiConfig.visibleFields.ALARMRULE_Class
               && (!objAttrs.class || objAttrs.class.length === 0)) {
      setErrMsg_UpdateGeneral(t("I18N_ERR_Need_alarm_class"));
      return;
    } else if (!objAttrs.type || objAttrs.type.length === 0) {
      setErrMsg_UpdateGeneral(t("I18N_ERR_Need_alarm_type"));
      return;
    } else if (!objAttrs.status || objAttrs.status.length === 0) {
      setErrMsg_UpdateGeneral(t("I18N_ERR_Need_alarm_status"));
      return;
    } else if (!objAttrs.impactType || objAttrs.impactType.length === 0) {
      setErrMsg_UpdateGeneral(t("I18N_ERR_Need_impact_type"));
      return;
    }

    if (!configInfo.uiConfig.visibleFields.ALARMRULE_Class) {
      // For customers who does not support explicit alarm classes, hardcoded using special rule

      // ##### THIS IS A TEMP HACK.  Long term solution maybe to introduce the Class concept for Alarm Category #####
      if (categoryList.find( item => item.id.toString() === objAttrs.categoryId.toString()).code === 'PREDICTIVE_NOTICES') {
        objAttrs.class = 'PREDICTIVE';
      } else {
        objAttrs.class = 'REALTIME';
      }
    }

    let reqBody = objAttrs;
    delete reqBody.triggerLogic;  // Trigger logic is edited separately elsewhere

    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_DATA_MGMT_API.patch("alarm-rules/" + objAttrs.id, reqBody);

        resolve(res.data);

        if (res.status === 200) {

          // Restore UI to viewing mode
          setEditModeGeneral(false);
          setErrMsg_UpdateGeneral('');

          // Refresh data to update Time Updated stamp, and in case there are other stale fields
          fetchObj(props.objDetails.id);
        }
      } catch (error) {
        if (!error.message || (error.message !== 'IGNORE')) {
          setErrMsg_UpdateGeneral(t(translateAPIError(error)));
        }
      }
    });

  }


  // --- Edit Trigger Logic
  const handleEditTriggerLogic = (e) => {
    e.preventDefault();
    setEditModeTriggerLogic(true);

    // If no trigger logic is defined yet
    if (Object.keys(objAttrs.triggerLogic).length === 0) {
      // Deep copy
      let newAttr = JSON.parse (JSON.stringify(objAttrs));

      newAttr.triggerLogic.ANYTIME      = true;
      newAttr.triggerLogic.OFFICE_HR    = false;
      newAttr.triggerLogic.NONOFFICE_HR = false;
      newAttr.triggerLogic.BIZ_HR       = false;
      newAttr.triggerLogic.NONBIZ_HR    = false;

      newAttr.triggerLogic.applTime = [];
      newAttr.triggerLogic.applTime.push('ANYTIME');

      setObjAttrs(newAttr);
    }
  }

  const handleClose = (e) => {
    e.preventDefault();

    // Return to list
    navigate(-1);
  }


  // dpType type stuff

  function handleAddAssocDpType() {
    setErrMsg_DpTypeSelect('');
    setShowDpTypeSelectDialog(true);
  }

  function handleAddAssocDp() {
    setErrMsg_DpSelect('');
    setShowDpSelectDialog(true);
  }


  function handleRemoveDpType(dpType) {

    // For derived alarm rule, check to see if this datapoint type is in use with the trigger logic
    if (objAttrs && objAttrs.triggerLogic && objAttrs.triggerLogic.scope === 'SCOPE_DP_TYPE') {
      const triggerLogic = objAttrs.triggerLogic;

      if (   (triggerLogic.condGrp1 && triggerLogic.condGrp1.cond1 && triggerLogic.condGrp1.cond1.dpId && (parseInt(triggerLogic.condGrp1.cond1.dpId) === dpType.id))
          || (triggerLogic.condGrp1 && triggerLogic.condGrp1.cond2 && triggerLogic.condGrp1.cond2.dpId && (parseInt(triggerLogic.condGrp1.cond2.dpId) === dpType.id))
          || (triggerLogic.condGrp2 && triggerLogic.condGrp2.cond3 && triggerLogic.condGrp2.cond3.dpId && (parseInt(triggerLogic.condGrp2.cond3.dpId) === dpType.id))
          || (triggerLogic.condGrp2 && triggerLogic.condGrp2.cond4 && triggerLogic.condGrp2.cond4.dpId && (parseInt(triggerLogic.condGrp2.cond4.dpId) === dpType.id))) {
        setErrMsg(t('I18N_ERR_DpType_in_use'));
        return;
      }
    }

    let reqBody = {
          data: {
            dpTypeIds: []
          }
        };

    reqBody.data.dpTypeIds.push(dpType.id);

    return new Promise(async (resolve, reject) => {
      try {

        const res = await axiosAuth_DATA_MGMT_API.delete("alarm-rules/" + objAttrs.id + "/dp-types/", reqBody);

        resolve(res.data);

        if (res.status === 200) {
          setErrMsg('');
          fetchAssociatedDpTypes(objAttrs.id);
        } else {
          // ##### NEED TO DECIDE WHAT TO DO #####
        }
      } catch (error) {
        setErrMsg(t(translateAPIError(error)));
      }
    });
  }


  function handleRemoveDp(dp) {

    // For derived alarm rule, check to see if this datapoint type is in use with the trigger logic
    if (objAttrs && objAttrs.triggerLogic && objAttrs.triggerLogic.scope === 'SCOPE_DP') {
      const triggerLogic = objAttrs.triggerLogic;

      if (   (triggerLogic.condGrp1 && triggerLogic.condGrp1.cond1 && triggerLogic.condGrp1.cond1.dpId && (parseInt(triggerLogic.condGrp1.cond1.dpId) === dp.id))
          || (triggerLogic.condGrp1 && triggerLogic.condGrp1.cond2 && triggerLogic.condGrp1.cond2.dpId && (parseInt(triggerLogic.condGrp1.cond2.dpId) === dp.id))
          || (triggerLogic.condGrp2 && triggerLogic.condGrp2.cond3 && triggerLogic.condGrp2.cond3.dpId && (parseInt(triggerLogic.condGrp2.cond3.dpId) === dp.id))
          || (triggerLogic.condGrp2 && triggerLogic.condGrp2.cond4 && triggerLogic.condGrp2.cond4.dpId && (parseInt(triggerLogic.condGrp2.cond4.dpId) === dp.id))) {
        setErrMsg(t('I18N_ERR_Dp_in_use'));
        return;
      }
    }

    let reqBody = {
          data: {
            datapointIds: []
          }
        };

    reqBody.data.datapointIds.push(dp.id);

    return new Promise(async (resolve, reject) => {
      try {

        const res = await axiosAuth_DATA_MGMT_API.delete("alarm-rules/" + objAttrs.id + "/datapoints/", reqBody);

        resolve(res.data);

        if (res.status === 200) {
          setErrMsg('');
          fetchAssociatedDps(objAttrs.id);
        }
      } catch (error) {
        setErrMsg(t(translateAPIError(error)));
      }
    });
  }


  function renderAssocDpType(dpType, index) {
    return (
      <tr key={index} style={{fontWeight:'300'}}>
        <td style={{width:"30%"}}>{dpType.code}</td>
        <td style={{width:"35%"}}>{dpType.description}</td>
        <td style={{width:"30%"}}>{dpType.subsystem}</td>
        <td style={{width:"5%"}}><span style={{cursor:'pointer', color:'SteelBlue'}} onClick={() => handleRemoveDpType(dpType)}><BiTrash size={16} /></span></td>
      </tr>
    )
  }


  function renderAssocDp(dp, index) {
    return (
      <tr key={index} style={{fontWeight:'300'}}>
        <td style={{width:"30%"}}>{dp.code}</td>
        <td style={{width:"35%"}}>{dp.description}</td>
        <td style={{width:"30%"}}></td>
        <td style={{width:"5%"}}><span style={{cursor:'pointer', color:'SteelBlue'}} onClick={() => handleRemoveDp(dp)}><BiTrash size={16} /></span></td>
      </tr>
    )
  }


  // Action stuff
/*
  function handleActionInfo(action) {

    setActionSelected(action);
    setShowActionInfo(true);
  }
*/

  function handleAddActions() {
    fetchUnassignedActions();
  }

  function handleAddActionsClose() {
    setActionAddList([]);
    setShowAddActionDialog(false);
  }

  function handleAddActionsSubmit() {
    let newActionList = [];

    if (actionAddList.length === 0) {
      setAddActionErrMsg(t("I18N_ERR_No_item_selected"));
      return;
    }

    for (let i=0; i<actionAddList.length; i++) {
      newActionList.push(actionAddList[i]);
    }

    let reqBody = {
          actionIds: newActionList
        };

    return new Promise(async (resolve, reject) => {
      try {

        const res = await axiosAuth_DATA_MGMT_API.post("alarm-rules/" + objAttrs.id + "/actions", reqBody);

        resolve(res.data);

        if (res.status === 200) {
          setActionAddList([]);
          setAddActionErrMsg('');
          setShowAddActionDialog(false);
          fetchAssociatedActions(objAttrs.id);
        } else {
          // ##### NEED TO DECIDE WHAT TO DO #####
        }
      } catch (error) {
        setAddActionErrMsg(t(translateAPIError(error)));
        return;
      }
    });
  }


  function handleRemoveAction(action) {

    let reqBody = {
          data: {
             "actionIds": []
          }
        };

    reqBody.data.actionIds.push(action.id);

    return new Promise(async (resolve, reject) => {
      try {

        const res = await axiosAuth_DATA_MGMT_API.delete("alarm-rules/" + objAttrs.id + "/actions/", reqBody);

        resolve(res.data);

        if (res.status === 200) {
          setErrMsg('');
          fetchAssociatedActions(objAttrs.id);
        } else {
          // ##### NEED TO DECIDE WHAT TO DO #####
        }
      } catch (error) {
        setErrMsg(t(translateAPIError(error)));
        return;
      }
    });
  }

  const handleActionSelect = (e) => {

    if (e.target.checked) {
      // Add action to the list
      actionAddList.push(e.target.id);
    } else {
      const index = actionAddList.indexOf(e.target.id);
      if (index > -1) {
        actionAddList.splice(index, 1);
      }
    }

    setActionAddList(actionAddList);
  }


  function renderAction(action, index) {
    return (
      <tr key={index} style={{fontWeight:'300'}}>
{/*
        <td><span style={{cursor:'pointer', color:'SteelBlue'}} onClick={() => handleActionInfo(action)}>{action.name}</span></td>
*/}
        <td style={{width:"30%"}}>{action.name}</td>
        <td style={{width:"35%"}}>{action.description}</td>
        <td style={{width:"30%"}}>{action.type}</td>
        <td style={{width:"5%"}}><span style={{cursor:'pointer', color:'SteelBlue'}} onClick={() => handleRemoveAction(action)}><BiTrash size={16} /></span></td>
      </tr>
    )
  }


  function renderAddActions(action, index) {
    return (
      <tr key={index} style={{fontWeight:'300'}}>
        <td style={{width:"5%"}}><Form.Check type="checkbox" id={action.id} label="" onChange={handleActionSelect} /></td>
        <td style={{width:"30%",wordBreak:"break-all"}}>{action.name}</td>
        <td style={{width:"30%"}}>{action.description}</td>
        <td style={{width:"35%",wordBreak:"break-all"}}>{action.type}</td>
      </tr>
    )
  }



/*
  function renderAlarm(alarm, index) {
    return (
      <tr key={index} style={{fontWeight:'300'}}>
        <td>{alarm.code}</td>
        <td>{t("custom:I18N_" + alarm.level)}</td>
        <td>{t("custom:I18N_" + alarm.status)}</td>
        <td>{alarm.remarks}</td>
        <td>{alarm.location}</td>
        <td>{alarm.assetId}</td>
        <td>{alarm.workorderId}</td>
        <td>{formatDate((new Date(0)).setUTCSeconds(alarm.timeStamp))}</td>
      </tr>
    )
  }
*/


  const onTriggerLogicAttrsInputChange = (e) => {
    // Clone (deep copy) trigger logic attr, for setting deeper layer attributes
    let newTriggerLogicAttrs = JSON.parse (JSON.stringify(triggerLogicAttrs));

    switch (e.target.name) {
      case 'value1':
        if (!newTriggerLogicAttrs.condGrp1.cond1)
          newTriggerLogicAttrs.condGrp1.cond1 = {};
        newTriggerLogicAttrs.condGrp1.cond1.value =  e.target.value;
        setTriggerLogicAttrs (newTriggerLogicAttrs);
        break;
      case 'value2':
        if (!newTriggerLogicAttrs.condGrp1.cond2)
          newTriggerLogicAttrs.condGrp1.cond2 = {};
        newTriggerLogicAttrs.condGrp1.cond2.value =  e.target.value;
        setTriggerLogicAttrs (newTriggerLogicAttrs);
        break;
      case 'value3':
        if (!newTriggerLogicAttrs.condGrp2.cond3)
          newTriggerLogicAttrs.condGrp2.cond3 = {};
        newTriggerLogicAttrs.condGrp2.cond3.value =  e.target.value;
        setTriggerLogicAttrs (newTriggerLogicAttrs);
        break;
      case 'value4':
        if (!newTriggerLogicAttrs.condGrp2.cond4)
          newTriggerLogicAttrs.condGrp2.cond4 = {};
        newTriggerLogicAttrs.condGrp2.cond4.value =  e.target.value;
        setTriggerLogicAttrs (newTriggerLogicAttrs);
        break;
      default:
        setTriggerLogicAttrs({ ...triggerLogicAttrs, [e.target.name]: e.target.value});
        break;
    }
  }


  const onTriggerLogicCheckboxSelect = (e) => {

    setTriggerLogicAttrs({ ...triggerLogicAttrs, [e.target.name]: e.target.checked });

    // Clone (deep copy) trigger logic attr
    let newTriggerLogic = JSON.parse (JSON.stringify(triggerLogicAttrs));

    if ((e.target.checked) && (!newTriggerLogic.applTime)) {
      newTriggerLogic.applTime = [];
    }

    switch (e.target.name) {
      case 'useOccCnt':
        newTriggerLogic.useOccCnt = e.target.checked;

        if (e.target.checked) {
          newTriggerLogic.useOccDur = false;
          newTriggerLogic.occDur = null;

          // Occur Count can only be used with a single condition.
          if (newTriggerLogic.condGrp1) {
            newTriggerLogic.condGrp1.condOp1 = null;
            newTriggerLogic.condGrp1.cond2 = null;
          }

          newTriggerLogic.condGrp2 = null;
        } else {
          newTriggerLogic.occCnt = null;
          newTriggerLogic.timeWindow = null;
          newTriggerLogic.timeWinUnit = null;
        }

        break;
      case 'useOccDur':
        newTriggerLogic.useOccDur = e.target.checked;

        if (e.target.checked) {
          newTriggerLogic.useOccCnt = false;
          newTriggerLogic.occCnt = null;
          newTriggerLogic.timeWindow = null;
          newTriggerLogic.timeWinUnit = null;
        } else {
          newTriggerLogic.occDur = null;
        }

        break;
      case 'ANYTIME':
        newTriggerLogic.ANYTIME = e.target.checked;
        if (e.target.checked) {
          // Mutually exclusive with all other
          newTriggerLogic.applTime = [];            // Clear array
          newTriggerLogic.applTime.push('ANYTIME');

          newTriggerLogic.OFFICE_HR    = false;
          newTriggerLogic.NONOFFICE_HR = false;
          newTriggerLogic.BIZ_HR       = false;
          newTriggerLogic.NONBIZ_HR    = false;

        } else {
          let index = newTriggerLogic.applTime.indexOf(e.target.name);
          if (index !== -1) {
            newTriggerLogic.applTime.splice(index, 1);
          }
        }

        break;
      case 'OFFICE_HR':
        newTriggerLogic.OFFICE_HR = e.target.checked;
        if (e.target.checked) {
          // Mutually exclusive with all other
          newTriggerLogic.applTime = [];            // Clear array
          newTriggerLogic.applTime.push('OFFICE_HR');

          newTriggerLogic.ANYTIME      = false;
          newTriggerLogic.NONOFFICE_HR = false;
          newTriggerLogic.BIZ_HR       = false;
          newTriggerLogic.NONBIZ_HR    = false;

        } else {
          let index = newTriggerLogic.applTime.indexOf(e.target.name);
          if (index !== -1) {
            newTriggerLogic.applTime.splice(index, 1);
          }
        }

        break;
      case 'NONOFFICE_HR':
        newTriggerLogic.NONOFFICE_HR = e.target.checked;
        if (e.target.checked) {
          // Mutually exclusive with all other
          newTriggerLogic.applTime = [];            // Clear array
          newTriggerLogic.applTime.push('NONOFFICE_HR');

          newTriggerLogic.ANYTIME   = false;
          newTriggerLogic.OFFICE_HR = false;
          newTriggerLogic.BIZ_HR    = false;
          newTriggerLogic.NONBIZ_HR = false;

        } else {
          let index = newTriggerLogic.applTime.indexOf(e.target.name);
          if (index !== -1) {
            newTriggerLogic.applTime.splice(index, 1);
          }
        }

        break;
      case 'BIZ_HR':
        newTriggerLogic.BIZ_HR = e.target.checked;
        if (e.target.checked) {
          // Mutually exclusive with all other
          newTriggerLogic.applTime = [];            // Clear array
          newTriggerLogic.applTime.push('BIZ_HR');

          newTriggerLogic.ANYTIME      = false;
          newTriggerLogic.OFFICE_HR    = false;
          newTriggerLogic.NONOFFICE_HR = false;
          newTriggerLogic.NONBIZ_HR    = false;

        } else {
          let index = newTriggerLogic.applTime.indexOf(e.target.name);
          if (index !== -1) {
            newTriggerLogic.applTime.splice(index, 1);
          }
        }

        break;
      case 'NONBIZ_HR':
        newTriggerLogic.NONBIZ_HR = e.target.checked;
        if (e.target.checked) {
          // Mutually exclusive with all other
          newTriggerLogic.applTime = [];            // Clear array
          newTriggerLogic.applTime.push('NONBIZ_HR');

          newTriggerLogic.ANYTIME      = false;
          newTriggerLogic.OFFICE_HR    = false;
          newTriggerLogic.NONOFFICE_HR = false;
          newTriggerLogic.BIZ_HR       = false;

        } else {
          let index = newTriggerLogic.applTime.indexOf(e.target.name);
          if (index !== -1) {
            newTriggerLogic.applTime.splice(index, 1);
          }
        }
        break;

      case 'SCOPE_DP_TYPE':
        if (triggerLogicAttrs.condGrp1) {
          // Switching scope voids data portion of previous trigger logic: needs user confirmation
          setScopeSelection ('SCOPE_DP_TYPE');
          setShowDeleteConfirmDialog(true);
        } else {
          newTriggerLogic.scope = 'SCOPE_DP_TYPE';
          newTriggerLogic.condGrp1 = null;
          newTriggerLogic.condGrp2 = null;
        }
        break;

      case 'SCOPE_DP':
        if (triggerLogicAttrs.condGrp1) {
          // Switching scope voids data portion of previous trigger logic: needs user confirmati
          setScopeSelection ('SCOPE_DP');
          setShowDeleteConfirmDialog(true);
        } else {
          newTriggerLogic.scope = 'SCOPE_DP';
          newTriggerLogic.condGrp1 = null;
          newTriggerLogic.condGrp2 = null;
        }
        break;

      default:
    }

    setTriggerLogicAttrs(newTriggerLogic);
  }

  const onTimeWinUnitSelect = (key, event) => {
    setTriggerLogicAttrs({ ...triggerLogicAttrs, timeWinUnit: key});
  };

  const onOperator1Select = (key, event) => {
    // Clone (deep copy) trigger logic attr
    let newTriggerLogicAttrs = JSON.parse (JSON.stringify(triggerLogicAttrs));

    if (!newTriggerLogicAttrs.condGrp1) {
      newTriggerLogicAttrs.condGrp1 = {};
    }

    if (!newTriggerLogicAttrs.condGrp1.cond1) {
      newTriggerLogicAttrs.condGrp1.cond1 = {};
    }

    newTriggerLogicAttrs.condGrp1.cond1.op = key;

    if (key === "EXISTS") {
      newTriggerLogicAttrs.condGrp1.cond1.value = null;
    }

    setTriggerLogicAttrs(newTriggerLogicAttrs);
  };

  const onOperator2Select = (key, event) => {
    // Clone (deep copy) trigger logic attr
    let newTriggerLogicAttrs = JSON.parse (JSON.stringify(triggerLogicAttrs));

    if (!newTriggerLogicAttrs.condGrp1) {
      newTriggerLogicAttrs.condGrp1 = {};
    }

    if (!newTriggerLogicAttrs.condGrp1.cond2) {
      newTriggerLogicAttrs.condGrp1.cond2 = {};
    }

    newTriggerLogicAttrs.condGrp1.cond2.op = key;

    if (key === "EXISTS") {
      newTriggerLogicAttrs.condGrp1.cond2.value = null;
    }

    setTriggerLogicAttrs(newTriggerLogicAttrs);
  };

  const onOperator3Select = (key, event) => {
    // Clone (deep copy) trigger logic attr
    let newTriggerLogicAttrs = JSON.parse (JSON.stringify(triggerLogicAttrs));

    if (!newTriggerLogicAttrs.condGrp2) {
      newTriggerLogicAttrs.condGrp2 = {};
    }

    if (!newTriggerLogicAttrs.condGrp2.cond3) {
      newTriggerLogicAttrs.condGrp2.cond3 = {};
    }

    newTriggerLogicAttrs.condGrp2.cond3.op = key;

    if (key === "EXISTS") {
      newTriggerLogicAttrs.condGrp2.cond3.value = null;
    }

    setTriggerLogicAttrs(newTriggerLogicAttrs);
  };

  const onOperator4Select = (key, event) => {
    // Clone (deep copy) trigger logic attr
    let newTriggerLogicAttrs = JSON.parse (JSON.stringify(triggerLogicAttrs));

    if (!newTriggerLogicAttrs.condGrp2) {
      newTriggerLogicAttrs.condGrp2 = {};
    }

    if (!newTriggerLogicAttrs.condGrp2.cond4) {
      newTriggerLogicAttrs.condGrp2.cond4 = {};
    }

    newTriggerLogicAttrs.condGrp2.cond4.op = key;

    if (key === "EXISTS") {
      newTriggerLogicAttrs.condGrp2.cond4.value = null;
    }

    setTriggerLogicAttrs(newTriggerLogicAttrs);
  };


  const onDpLogicOp1Select = (key, event) => {
    // Clone (deep copy) trigger logic attr
    let newTriggerLogicAttrs = JSON.parse (JSON.stringify(triggerLogicAttrs));

    if (!newTriggerLogicAttrs.condGrp1) {
      newTriggerLogicAttrs.condGrp1 = {};
    }

    newTriggerLogicAttrs.condGrp1.condOp1 = key;

    if (key === 'None') {
      // Removing Condition 2
      newTriggerLogicAttrs.condGrp1.condOp1 = null;
      newTriggerLogicAttrs.condGrp1.cond2 = null;
    } else {
      if (triggerLogicAttrs.scope === 'SCOPE_DP_TYPE') {
        if (!newTriggerLogicAttrs.condGrp1.cond2)
          newTriggerLogicAttrs.condGrp1.cond2 = {};

        if (   (newTriggerLogicAttrs.condGrp1.cond1)
            && (newTriggerLogicAttrs.condGrp1.cond1.dp)) {
          newTriggerLogicAttrs.condGrp1.cond2.dp   = newTriggerLogicAttrs.condGrp1.cond1.dp;
          newTriggerLogicAttrs.condGrp1.cond2.dpId = newTriggerLogicAttrs.condGrp1.cond1.dpId;
        }
      }
    }

    setTriggerLogicAttrs(newTriggerLogicAttrs);
  };


  const onDpLogicOp2Select = (key, event) => {
    // Clone (deep copy) trigger logic attr
    let newTriggerLogicAttrs = JSON.parse (JSON.stringify(triggerLogicAttrs));

    if (!newTriggerLogicAttrs.condGrp2) {
      newTriggerLogicAttrs.condGrp2 = {};
    }

    newTriggerLogicAttrs.condGrp2.condOp2 = key;

    if (key === 'None') {
      newTriggerLogicAttrs.condGrp2.condOp2 = null;
      newTriggerLogicAttrs.condGrp2.cond4 = null;
    } else {
      if (!newTriggerLogicAttrs.condGrp2.cond4)
        newTriggerLogicAttrs.condGrp2.cond4 = {};

      if (   (triggerLogicAttrs.scope === 'SCOPE_DP_TYPE')
          && (newTriggerLogicAttrs.condGrp1)
          && (newTriggerLogicAttrs.condGrp1.cond1)
          && (newTriggerLogicAttrs.condGrp1.cond1.dp)) {
        newTriggerLogicAttrs.condGrp2.cond4.dp   = newTriggerLogicAttrs.condGrp1.cond1.dp;
        newTriggerLogicAttrs.condGrp2.cond4.dpId = newTriggerLogicAttrs.condGrp1.cond1.dpId;
      }
    }

    setTriggerLogicAttrs(newTriggerLogicAttrs);
  };


  // DpType select dialog stuff

/*
  const handleDpTypePicker = (dpMode) => {
    setErrMsg_DpTypeSelect('');
    setShowDpTypeSelectDialog(true);
  }
*/

  const handleDpTypeSearch = (e) => {
    e.preventDefault();

    if (dpTypeSearchTerm === '') {
      setErrMsg_DpTypeSelect(t('I18N_ERR_Need_search_term'));
      setDpTypeSearchTerm('');
      setDpTypeList([]);
      return;
    }

    // Replace any space and comma with '%', and wrap the with '%'

    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_DATA_MGMT_API.get("datapoint-types?searchTerms=" + dpTypeSearchTerm + "&searchField=CODE");

        resolve(res.data.data);

        if (res.status === 200) {

          // Filter out dp type that are already associated with the alarm rule
          const cleanList = res.data.data.filter(dpType => dpType.code !== '--');  // ##### Filter out garbage.  Once data is clearn, can remove this

          // Remove dpType types already associated with the alarm rule
          let dpTypeNamesArray = [];

          for (let i=0; i<assocDpTypeList.length; i++) {
            dpTypeNamesArray.push(assocDpTypeList[i].code);
          }

          let unassignedDpTypesArray = [];
          for (let i=0; i<cleanList.length; i++) {
            if (!dpTypeNamesArray.includes(cleanList[i].code)) {
              unassignedDpTypesArray.push(cleanList[i]);
            }
          }

          setDpTypeList(unassignedDpTypesArray);
        }

        setErrMsg_DpTypeSelect('');
      } catch (error) {
        if (!error.message || (error.message !== 'IGNORE')) {
          setErrMsg_DpTypeSelect(t(translateAPIError(error)));
        }
      }
    });

  }


  function handleDpTypeSelectCancel() {
    setErrMsg_DpTypeSelect('');
    setShowDpTypeSelectDialog(false);
  }

  function handleAssocDpTypeSelCancel() {
    setErrMsg_FormulaDpTypeSel('');
    setShowFormulaDpTypeSelDialog(false);
  }

  // This method serves two usages of datapoint type select:
  // 1. Associating dt type directly to the alarm rule, and
  // 2. Dp types used in conditions

  function handleDpTypeSelect(dpType, mode) {

    if (mode === 'ASSOC_SELECT') {

      let reqBody = {
            "dpTypeIds": []
          };

      reqBody.dpTypeIds.push(dpType.id);

      return new Promise(async (resolve, reject) => {
        try {

          const res = await axiosAuth_DATA_MGMT_API.post("alarm-rules/" + objAttrs.id + "/dp-types", reqBody);

          resolve(res.data);

          if (res.status === 200) {
            setErrMsg_DpTypeSelect('');
            setDpTypeSearchTerm('');
            setDpTypeList(null);
            setShowDpTypeSelectDialog(false);

            fetchAssociatedDpTypes(objAttrs.id);
          } else {
            // ##### NEED TO DECIDE WHAT TO DO #####
          }
        } catch (error) {
          setErrMsg_DpTypeSelect(t(translateAPIError(error)));
        }
      });

    } else if (mode === 'FORMULA_SELECT') {

      // THIS IS RELATED TO DATAPOINT TYPE SUPPORT FOR TRIGGER LOGIC
      // Use the shared logic as SCOPE_DP mode, since the only object attributes used are id and code.
      processDataObjSelect(dpType);

      setErrMsg_FormulaDpTypeSel('');
      setDpTypeSearchTerm('');
      setDpTypeList(null);
      setShowFormulaDpTypeSelDialog(false);

    } else {
      // ##### SHOULD NOT COME HERE #####
    }
  }

  const onDpTypeSearchInputChange = (e) => {
    setDpTypeSearchTerm(e.target.value);
  }

  function renderDpType(dpType, mode) {
    return (
      <tr style={{fontWeight:'300'}}>
        <td style={{width: "40%"}}>{dpType.code}</td>
        <td style={{width: "40%"}}>{dpType.description}</td>
        <td style={{width: "20%"}}>
          <Button size="tiny" variant="outline-secondary" style={{ float: 'left' }} onClick={() => handleDpTypeSelect(dpType, mode)}>
            {t("I18N_Select")}
          </Button>
       </td>
      </tr>
    )
  }

  // Datapoint select dialog stuff

  const handleDataPicker = (dpMode) => {
    setDpSelectMode(dpMode);
    setErrMsg_DpSelect('');

    if (triggerLogicAttrs.scope === 'SCOPE_DP_TYPE') {
      setShowFormulaDpTypeSelDialog(true);
    } else {
      setShowFormulaDpSelDialog(true);
    }
  }

  const handleDatapointSearch = (e) => {
    e.preventDefault();

    if (dpSearchTerm === '') {
      setErrMsg_DpSelect(t('I18N_ERR_Need_search_term'));
      setDpSearchTerm('');
      setDpList([]);
      return;
    }

    // Replace any space and comma with '%', and wrap the with '%'

    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_DATA_MGMT_API.get("datapoints?searchTerms=" + dpSearchTerm + "&searchField=CODE");

        resolve(res.data);

        if (res.status === 200) {

          // Filter out dp that are already associated with the alarm rule
          const cleanList = res.data.data;

          // Remove datapoints already associated with the alarm rule
          let dpNamesArray = [];

          for (let i=0; i<assocDpList.length; i++) {
            dpNamesArray.push(assocDpList[i].code);
          }

          let unassignedDpsArray = [];
          for (let i=0; i<cleanList.length; i++) {
            if (!dpNamesArray.includes(cleanList[i].code)) {
              unassignedDpsArray.push(cleanList[i]);
            }
          }

          setDpList(unassignedDpsArray);
        }

        setErrMsg_DpSelect('');
      } catch (error) {
        if (!error.message || (error.message !== 'IGNORE')) {
          setErrMsg_DpSelect(t(translateAPIError(error)));
        }
      }
    });

  }


  function handleDatapointSelectCancel() {
    setErrMsg_DpSelect('');
    setShowDpSelectDialog(false);
  }

  function handleFormulaDpSelCancel() {
    setErrMsg_FormulaDpSel('');
    setShowFormulaDpSelDialog(false);
  }


  function handleDatapointSelect(datapoint, mode) {

    if (mode === 'ASSOC_SELECT') {

      let reqBody = {
            "datapointIds": []
          };

      reqBody.datapointIds.push(datapoint.id);

      return new Promise(async (resolve, reject) => {
        try {

          const res = await axiosAuth_DATA_MGMT_API.post("alarm-rules/" + objAttrs.id + "/datapoints", reqBody);

          resolve(res.data);

          if (res.status === 200) {
            setErrMsg_DpSelect('');
            setDpSearchTerm('');
            setDpList(null);
            setShowDpSelectDialog(false);

            fetchAssociatedDps(objAttrs.id);
          } else {
            // ##### NEED TO DECIDE WHAT TO DO #####
          }
        } catch (error) {
          setErrMsg_DpSelect(t(translateAPIError(error)));
        }
      });

    } else if (mode === 'FORMULA_SELECT') {

      processDataObjSelect(datapoint);

      setErrMsg_FormulaDpSel('');
      setDpSearchTerm('');
      setShowFormulaDpSelDialog(false);

    } else {
      // ##### SHOULD NOT COME HERE #####
    }
  }

  function processDataObjSelect(datapoint) {

    // Deep copy
    let newTriggerLogicAttrs = JSON.parse (JSON.stringify(triggerLogicAttrs));

    if (dpSelectMode === 'DATAPOINT1') {

      if (newTriggerLogicAttrs.condGrp1 == null) {
        newTriggerLogicAttrs.condGrp1 = {};
      }

      if (newTriggerLogicAttrs.condGrp1.cond1 == null) {
        newTriggerLogicAttrs.condGrp1.cond1 = {};
      }
      newTriggerLogicAttrs.condGrp1.cond1.dpId  = datapoint.id;
      newTriggerLogicAttrs.condGrp1.cond1.dp    = datapoint.code;
      newTriggerLogicAttrs.condGrp1.cond1.op    = '';
      newTriggerLogicAttrs.condGrp1.cond1.value = '';

      if (triggerLogicAttrs.scope === 'SCOPE_DP_TYPE') {
        // For scope being Datapoint Type, propagate the selection to all conditions
        if (newTriggerLogicAttrs.condGrp1.cond2) {
          newTriggerLogicAttrs.condGrp1.cond2.dpId  = datapoint.id;
          newTriggerLogicAttrs.condGrp1.cond2.dp    = datapoint.code;
        }

        if (newTriggerLogicAttrs.condGrp2 && newTriggerLogicAttrs.condGrp2.cond3) {
          newTriggerLogicAttrs.condGrp2.cond3.dpId  = datapoint.id;
          newTriggerLogicAttrs.condGrp2.cond3.dp    = datapoint.code;
        }

        if (newTriggerLogicAttrs.condGrp2 && newTriggerLogicAttrs.condGrp2.cond4) {
          newTriggerLogicAttrs.condGrp2.cond4.dpId  = datapoint.id;
          newTriggerLogicAttrs.condGrp2.cond4.dp    = datapoint.code;
        }

      }

    } else if (dpSelectMode === 'DATAPOINT2') {

      if (newTriggerLogicAttrs.condGrp1 == null) {
        newTriggerLogicAttrs.condGrp1 = {};
      }

      if (newTriggerLogicAttrs.condGrp1.cond2 == null) {
        newTriggerLogicAttrs.condGrp1.cond2 = {};
      }
      newTriggerLogicAttrs.condGrp1.cond2.dpId  = datapoint.id;
      newTriggerLogicAttrs.condGrp1.cond2.dp    = datapoint.code;
      newTriggerLogicAttrs.condGrp1.cond2.op    = '';
      newTriggerLogicAttrs.condGrp1.cond2.value = '';

    } else if (dpSelectMode === 'DATAPOINT3') {

      if (newTriggerLogicAttrs.condGrp2 == null) {
        newTriggerLogicAttrs.condGrp2 = {};
      }

      if (newTriggerLogicAttrs.condGrp2.cond3 == null) {
        newTriggerLogicAttrs.condGrp2.cond3 = {};
      }
      newTriggerLogicAttrs.condGrp2.cond3.dpId  = datapoint.id;
      newTriggerLogicAttrs.condGrp2.cond3.dp    = datapoint.code;
      newTriggerLogicAttrs.condGrp2.cond3.op    = '';
      newTriggerLogicAttrs.condGrp2.cond3.value = '';

    } else if (dpSelectMode === 'DATAPOINT4') {

      if (newTriggerLogicAttrs.condGrp2 == null) {
        newTriggerLogicAttrs.condGrp2 = {};
      }

      if (newTriggerLogicAttrs.condGrp2.cond4 == null) {
        newTriggerLogicAttrs.condGrp2.cond4 = {};
      }
      newTriggerLogicAttrs.condGrp2.cond4.dpId  = datapoint.id;
      newTriggerLogicAttrs.condGrp2.cond4.dp    = datapoint.code;
      newTriggerLogicAttrs.condGrp2.cond4.op    = '';
      newTriggerLogicAttrs.condGrp2.cond4.value = '';

    }

/*
    // For the current time being, only support 1 datapoint type, so the selection applies to both conditions
    if (newTriggerLogicAttrs.condGrp1.cond1 == null) {
      newTriggerLogicAttrs.condGrp1.cond1 = {};
      newTriggerLogicAttrs.condGrp1.cond1.op    = '';
      newTriggerLogicAttrs.condGrp1.cond1.value = '';
    }

    newTriggerLogicAttrs.condGrp1.cond1.dpId = datapoint.id;
    newTriggerLogicAttrs.condGrp1.cond1.dp   = datapoint.code;

    if (newTriggerLogicAttrs.condGrp1.cond2 == null) {
      newTriggerLogicAttrs.condGrp1.cond2 = {};
      newTriggerLogicAttrs.condGrp1.cond2.op    = '';
      newTriggerLogicAttrs.condGrp1.cond2.value = '';
    }

    newTriggerLogicAttrs.condGrp1.cond2.dpId = datapoint.id;
    newTriggerLogicAttrs.condGrp1.cond2.dp   = datapoint.code;
*/

    setTriggerLogicAttrs(newTriggerLogicAttrs);
  }

  const onDatapointSearchInputChange = (e) => {
    setDpSearchTerm(e.target.value);
  }

  function renderDatapoint(datapoint, mode) {
    return (
      <tr style={{fontWeight:'300'}}>
        <td style={{width: "40%"}}>{datapoint.code}</td>
        <td style={{width: "40%"}}>{datapoint.description}</td>
        <td style={{width: "20%"}}>
          <Button size="tiny" variant="outline-secondary" style={{ float: 'left' }} onClick={() => handleDatapointSelect(datapoint, mode)}>
            {t("I18N_Select")}
          </Button>
       </td>
      </tr>
    )
  }


  const handleEditTriggerLogicCancel = (e) => {
    e.preventDefault();

    // Reset fields
    setTriggerLogicAttrs(currentTriggerLogicAttrs);

    setErrMsg_UpdateTriggerLogic('');
    setEditModeTriggerLogic(false);
  }


  const handleEditTriggerLogicSubmit = (e) => {
    e.preventDefault();

    setErrMsg_UpdateTriggerLogic("");

    // Validation

    if (triggerLogicAttrs.useOccCnt) {
      if ((triggerLogicAttrs.occCnt == null) || (triggerLogicAttrs.occCnt.length === 0)) {
        setErrMsg_UpdateTriggerLogic(t("I18N_ERR_Validate_occur_count_value"));
        return;
      } else if (!isNaturalNumber(triggerLogicAttrs.occCnt)) {
        setErrMsg_UpdateTriggerLogic(t("I18N_ERR_Validate_occur_count_value"));
        return;
      } else if (Number(triggerLogicAttrs.occCnt) < 2) {
        setErrMsg_UpdateTriggerLogic(t("I18N_ERR_Validate_occur_count_value"));
        return;
      } else if (!isNaturalNumber(triggerLogicAttrs.timeWindow)) {
        setErrMsg_UpdateTriggerLogic(t("I18N_ERR_Time_win_must_be_num"));
        return;
      } else if ((triggerLogicAttrs.timeWinUnit == null) || (triggerLogicAttrs.timeWinUnit.length === 0)) {
        setErrMsg_UpdateTriggerLogic(t("I18N_ERR_Validate_time_win_unit"));
        return;
      }
    }

    if (triggerLogicAttrs.useOccDur) {
      if ((triggerLogicAttrs.occDur == null) || (triggerLogicAttrs.occDur.length === 0)) {
        setErrMsg_UpdateTriggerLogic(t("I18N_ERR_Validate_occur_duration_value"));
        return;
      } else if (!isNaturalNumber(triggerLogicAttrs.occDur)) {
        setErrMsg_UpdateTriggerLogic(t("I18N_ERR_Validate_occur_duration_value"));
        return;
      }
    }

    if (   !triggerLogicAttrs.condGrp1                      || !triggerLogicAttrs.condGrp1.cond1
        || !triggerLogicAttrs.condGrp1.cond1.dpId
        || (triggerLogicAttrs.condGrp1.cond1.op    == null) || (triggerLogicAttrs.condGrp1.cond1.op.length    === 0)
        || (   (triggerLogicAttrs.condGrp1.cond1.op !== 'EXISTS')
            && ((triggerLogicAttrs.condGrp1.cond1.value == null) || (triggerLogicAttrs.condGrp1.cond1.value.length === 0)))) {
      setErrMsg_UpdateTriggerLogic(t("I18N_ERR_AlarmRule_invalid_cond1"));
      return;
    }

    if (   (   triggerLogicAttrs.condGrp1.condOp1
            && (triggerLogicAttrs.condGrp1.condOp1.length > 0)
            && (triggerLogicAttrs.condGrp1.condOp1 !== 'None'))
        && (   !triggerLogicAttrs.condGrp1.cond2                || !triggerLogicAttrs.condGrp1.cond2.dpId
            || (triggerLogicAttrs.condGrp1.cond2.op    == null) || (triggerLogicAttrs.condGrp1.cond2.op.length    === 0)
            || (   (triggerLogicAttrs.condGrp1.cond2.op !== 'EXISTS')
                && ((triggerLogicAttrs.condGrp1.cond2.value == null) || (triggerLogicAttrs.condGrp1.cond2.value.length === 0))))) {
      setErrMsg_UpdateTriggerLogic(t("I18N_ERR_AlarmRule_invalid_cond2"));
      return;
    }

    if (triggerLogicAttrs.condGrp1) {
      if (   (triggerLogicAttrs.condGrp1.cond1)
          && (triggerLogicAttrs.condGrp1.cond1.value)
          && (triggerLogicAttrs.condGrp1.cond1.value.length > 20)) {
        setErrMsg_UpdateTriggerLogic(t("I18N_ERR_Max_len_op_value") + 20);
        return;
      }

      if (   (triggerLogicAttrs.condGrp1.cond2)
          && (triggerLogicAttrs.condGrp1.cond2.value)
          && (triggerLogicAttrs.condGrp1.cond2.value.length > 20)) {
        setErrMsg_UpdateTriggerLogic(t("I18N_ERR_Max_len_op_value") + 20);
        return;
      }
    }

    if (triggerLogicAttrs.condGrp2 != null) {

      if (   !triggerLogicAttrs.condGrp2.cond3
          || !triggerLogicAttrs.condGrp2.cond3.dpId
          || (triggerLogicAttrs.condGrp2.cond3.op    == null) || (triggerLogicAttrs.condGrp2.cond3.op.length    === 0)
          || (   (triggerLogicAttrs.condGrp2.cond3.op !== 'EXISTS')
              && ((triggerLogicAttrs.condGrp2.cond3.value == null) || (triggerLogicAttrs.condGrp2.cond3.value.length === 0)))) {
        setErrMsg_UpdateTriggerLogic(t("I18N_ERR_AlarmRule_invalid_cond3"));
        return;
      }

      if (   (   triggerLogicAttrs.condGrp2.condOp2
              && (triggerLogicAttrs.condGrp2.condOp2.length > 0)
              && (triggerLogicAttrs.condGrp2.condOp2 !== 'None'))
          && (   !triggerLogicAttrs.condGrp2.cond4                || !triggerLogicAttrs.condGrp2.cond4.dpId
              || (triggerLogicAttrs.condGrp2.cond4.op    == null) || (triggerLogicAttrs.condGrp2.cond4.op.length    === 0)
              || (   (triggerLogicAttrs.condGrp2.cond4.op !== 'EXISTS')
                  && ((triggerLogicAttrs.condGrp2.cond4.value == null) || (triggerLogicAttrs.condGrp2.cond4.value.length === 0))))) {
        setErrMsg_UpdateTriggerLogic(t("I18N_ERR_AlarmRule_invalid_cond4"));
        return;
      }

      if (   (triggerLogicAttrs.condGrp2.cond3)
          && (triggerLogicAttrs.condGrp2.cond3.value)
          && (triggerLogicAttrs.condGrp2.cond3.value.length > 20)) {
        setErrMsg_UpdateTriggerLogic(t("I18N_ERR_Max_len_op_value") + 20);
        return;
      }

      if (   (triggerLogicAttrs.condGrp2.cond4)
          && (triggerLogicAttrs.condGrp2.cond4.value)
          && (triggerLogicAttrs.condGrp2.cond4.value.length > 20)) {
        setErrMsg_UpdateTriggerLogic(t("I18N_ERR_Max_len_op_value") + 20);
        return;
      }
    }

    let reqBody = {};

    reqBody.id = objAttrs.id;

    reqBody.triggerLogic = {}

    reqBody.triggerLogic.scope = triggerLogicAttrs.scope;

    if (triggerLogicAttrs.useOccCnt) {
      reqBody.triggerLogic.useOccCnt   = triggerLogicAttrs.useOccCnt;
      reqBody.triggerLogic.occCnt      = Number(triggerLogicAttrs.occCnt);
      reqBody.triggerLogic.timeWindow  = Number(triggerLogicAttrs.timeWindow);
      reqBody.triggerLogic.timeWinUnit = triggerLogicAttrs.timeWinUnit;
    }

    if (triggerLogicAttrs.useOccDur) {
      reqBody.triggerLogic.useOccDur = triggerLogicAttrs.useOccDur;
      reqBody.triggerLogic.occDur    = Number(triggerLogicAttrs.occDur);
    }

    reqBody.triggerLogic.applTime  = triggerLogicAttrs.applTime;

    reqBody.triggerLogic.condGrp1 = {};
    reqBody.triggerLogic.condGrp1.cond1   = triggerLogicAttrs.condGrp1.cond1;
    reqBody.triggerLogic.condGrp1.cond2   = triggerLogicAttrs.condGrp1.cond2;
    reqBody.triggerLogic.condGrp1.condOp1 = triggerLogicAttrs.condGrp1.condOp1;

    if (triggerLogicAttrs.condGrp2 && triggerLogicAttrs.condGrp2.cond3) {
      //reqBody.triggerLogic.condGrpOp      = triggerLogicAttrs.condGrpOp;
      reqBody.triggerLogic.condGrpOp        = "AND";    // #####  For the time being, force to AND #####

      reqBody.triggerLogic.condGrp2 = {};
      reqBody.triggerLogic.condGrp2.cond3   = triggerLogicAttrs.condGrp2.cond3;
      reqBody.triggerLogic.condGrp2.cond4   = triggerLogicAttrs.condGrp2.cond4;
      reqBody.triggerLogic.condGrp2.condOp2 = triggerLogicAttrs.condGrp2.condOp2;
    }


    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_DATA_MGMT_API.patch("alarm-rules/" + objAttrs.id, reqBody);

        resolve(res.data);

        if (res.status === 200) {

          // Restore UI to viewing mode
          setEditModeTriggerLogic(false);
          setErrMsg_UpdateTriggerLogic('');

          setCurrentTriggerLogicAttrs(triggerLogicAttrs);

/*
          // ##### No longer needed, since now formula only use explicitely assocated datapoint or dp types. #####
          // Update datapoint or datapoint type to alarm rule association

          let dataIds = [triggerLogicAttrs.condGrp1.cond1.dpId];

          if (   triggerLogicAttrs.condGrp1.cond2
              && (dataIds.indexOf(triggerLogicAttrs.condGrp1.cond2.dpId) < 0)) {
            dataIds.push(triggerLogicAttrs.condGrp1.cond2.dpId);
          }

          if (   triggerLogicAttrs.condGrp2 && triggerLogicAttrs.condGrp2.cond3
              && (dataIds.indexOf(triggerLogicAttrs.condGrp2.cond3.dpId) < 0)) {
            dataIds.push(triggerLogicAttrs.condGrp2.cond3.dpId);
          }

          if (   triggerLogicAttrs.condGrp2 && triggerLogicAttrs.condGrp2.cond4
              && (dataIds.indexOf(triggerLogicAttrs.condGrp2.cond4.dpId) < 0)) {
            dataIds.push(triggerLogicAttrs.condGrp2.cond4.dpId);
          }

          let reqBody, type;

          if (triggerLogicAttrs.scope === 'SCOPE_DP_TYPE') {
            reqBody = { datapointIds: dataIds };
            type = "datapoints";
          } else {
            reqBody = { datapointIds: dataIds };
            type = "dp-types";
          }

          return new Promise(async (resolve, reject) => {
            try {

              const res = await axiosAuth_DATA_MGMT_API.put("alarm-rules/" + objAttrs.id + "/" + type, reqBody);

              resolve(res.data);

              if (res.status === 200) {

                setErrMsg_UpdateTriggerLogic('');
                setEditModeTriggerLogic(false);

                fetchObj(objAttrs.id);
              } else {
                // ##### NEED TO DECIDE WHAT TO DO #####
              }
            } catch (error) {
              setErrMsg_UpdateTriggerLogic(t(translateAPIError(error)));
            }
          });
*/
        }
      } catch (error) {
        if (!error.message || (error.message !== 'IGNORE')) {
          setErrMsg_UpdateTriggerLogic(t(translateAPIError(error)));
        }
      }
    });
  }


  function handleDeleteCond(condId) {

    // Deep copy
    let newTriggerLogicAttrs = JSON.parse (JSON.stringify(triggerLogicAttrs));

    if (condId === 'CONDITION1') {
      newTriggerLogicAttrs.condGrp1.cond1 = null;

      // When scope is datapoint type, since datapoint type of later conditions depends on condition 1,
      // when condition is deleted, need to automatically delete the other conditions.
      if (newTriggerLogicAttrs.scope === 'SCOPE_DP_TYPE') {
        newTriggerLogicAttrs.condGrp1.condOp1 = null;
        newTriggerLogicAttrs.condGrp1.cond2 = null;
        newTriggerLogicAttrs.condGrp2 = null;
      }
    } else if (condId === 'CONDITION2') {

      newTriggerLogicAttrs.condGrp1.condOp1 = null;
      newTriggerLogicAttrs.condGrp1.cond2   = null;

    } else if (condId === 'CONDITION3') {

      if (!newTriggerLogicAttrs.condGrp2.cond4 || (newTriggerLogicAttrs.condGrp2.cond4 === null)) {
        // If no more conditions in the group 2, remove the whole group
        newTriggerLogicAttrs.condGrp2 = null;
      } else {
        newTriggerLogicAttrs.condGrp2.cond3 = null;

        if (newTriggerLogicAttrs.scope === 'SCOPE_DP_TYPE') {
          if (newTriggerLogicAttrs.condGrp1.cond1 && newTriggerLogicAttrs.condGrp1.cond1.dp) {
            newTriggerLogicAttrs.condGrp2.cond3 = {};
            newTriggerLogicAttrs.condGrp2.cond3.dp   = newTriggerLogicAttrs.condGrp1.cond1.dp;
            newTriggerLogicAttrs.condGrp2.cond3.dpId = newTriggerLogicAttrs.condGrp1.cond1.dpId;
          }
        }
      }

    } else if (condId === 'CONDITION4') {

      if (!newTriggerLogicAttrs.condGrp2.cond3 || (newTriggerLogicAttrs.condGrp2.cond3 === null)) {
        // If no more conditions in the group 2, remove the whole group
        newTriggerLogicAttrs.condGrp2 = null;
      } else {
        newTriggerLogicAttrs.condGrp2.condOp2 = null;
        newTriggerLogicAttrs.condGrp2.cond4   = null;
      }
    }

    setTriggerLogicAttrs(newTriggerLogicAttrs);
  }


  // Sound picket dialog stuff

  const handleSoundPicker = (e) => {
    e.preventDefault();
    setShowSoundPickerDialog(true);
  }

  function handleSoundPickerClose() {
    setShowSoundPickerDialog(false);
  }

  function handleSoundSelect(sound) {

    let tmpAttrs = {};
    tmpAttrs.soundId   = sound.id;
    tmpAttrs.soundName = sound.name;

    setObjAttrs({ ...objAttrs, ...tmpAttrs});

    setShowSoundPickerDialog(false);
  }

  const handleSoundDelete = (e) => {

    let tmpAttrs = {};
    tmpAttrs.soundId   = null;
    tmpAttrs.soundName = null;

    setObjAttrs({ ...objAttrs, ...tmpAttrs});
  }

  function handleAddCondGrp2() {
    let newTriggerLogic = JSON.parse (JSON.stringify(triggerLogicAttrs));
    newTriggerLogic.condGrp2 = {cond3: {}};

    if (   (newTriggerLogic.scope === 'SCOPE_DP_TYPE')
        && (newTriggerLogic.condGrp1 && newTriggerLogic.condGrp1.cond1 && newTriggerLogic.condGrp1.cond1.dp)) {
      newTriggerLogic.condGrp2.cond3.dp   = newTriggerLogic.condGrp1.cond1.dp;
      newTriggerLogic.condGrp2.cond3.dpId = newTriggerLogic.condGrp1.cond1.dpId;
    }

    setTriggerLogicAttrs(newTriggerLogic);
  }

  function handleRemoveCondGrp2() {
    let newTriggerLogic = JSON.parse (JSON.stringify(triggerLogicAttrs));
    newTriggerLogic.condGrp2 = null;
    setTriggerLogicAttrs(newTriggerLogic);
  }


  // ----- Delete Confirmation Dialog -----

  const [scopeSelection,          setScopeSelection]          = useState(null);
  const [showDeleteConfirmDialog, setShowDeleteConfirmDialog] = useState(false);
  const [errMsgDeleteConfirm,     setErrMsgDeleteConfirm]     = useState('');

  function handleObjDeleteCancel() {
    setScopeSelection(null);
    setErrMsgDeleteConfirm('');
    setShowDeleteConfirmDialog(false);
  }

  function handleObjDeleteSubmit() {

    // Clone (deep copy) trigger logic attr, for setting deeper layer attributes
    let newTriggerLogic = JSON.parse (JSON.stringify(triggerLogicAttrs));

    newTriggerLogic.scope = scopeSelection;
    newTriggerLogic.condGrp1 = null;
    newTriggerLogic.condGrp2 = null;

    setTriggerLogicAttrs(newTriggerLogic);

    setShowDeleteConfirmDialog(false);
  }

  // ----- END - Delete Confirmation Dialog -----


  return (
    <>
      <Card style={{overflow:'auto', border:'0', boxShadow:'0 2px 2px 0px rgba(0,0,0,0.1)',
                    padding:'20px 40px 20px 40px', maxWidth:'2500px', width:'100%', fontSize:'13px'}}>

        <div style={{display:'flex'}}>
          <span className={classes.admin_pages__page_title}>
            {t("I18N_AlarmRule_Details")}
          </span>
        </div>

        <div style={{maxHeight:'680px', overflow:'auto'}}>

          <div className={classes.admin_pages__page_subtitle} style={{marginTop:'20px'}}>
            <div display='flex'>
              <span>
                {t("I18N_AlarmRule_info")}
              </span>
              {editModeGeneral ?
                null
                :
                <span style={{marginLeft:'15px', fontSize:'9px', color:'SteelBlue', cursor:'pointer'}} onClick={handleEditGeneral}>
                  <PencilIcon size={12} />
                  {t("I18N_Edit")}
                </span>
              }
            </div>

            <hr className="solid" style={{ margin: '0 0 10px 0' }}></hr>

            {editModeGeneral ?
              <Container>
                <form>
                  <Row className={classes.admin_pages__field_label}>
                    <Col sm={3}>{t("I18N_AlarmRule_code")}: *</Col>
                    <Col sm={3}>{t("I18N_Description")}: *</Col>
                    <Col sm={3}>{t("I18N_Alarm_category")}: *</Col>
                    <Col sm={3}>{t("I18N_Default_level")}: *</Col>
                  </Row>
                  <Row className={classes.admin_pages__field_value}>
                    <Col sm={3}>
                      <input className={classes.admin_pages__field_editable} style={{width:'100%'}} name="code"
                        value={objAttrs.code ? objAttrs.code : ''}
                        onChange={(e) => onAttrsInputChange(e)} />
                    </Col>
                    <Col sm={3}>
                      <textarea className={classes.admin_pages__field_editable} style={{width:'100%'}} name="description"
                        value={objAttrs.description ? objAttrs.description : ''}
                        onChange={(e) => onAttrsInputChange(e)} />
                    </Col>
                    <Col sm={3}>
                      <Dropdown>
                        <Dropdown.Toggle size="tiny_dropdown" variant="outline-secondary" className={classes.dropdown_item_wrap} id="dropdown-basic-button">
                          {!objAttrs.categoryId ? t("common:I18N_DROPDOWN_PROMPT") :
                             (categoryList.find( ({ id }) => id === parseInt(objAttrs.categoryId) )).code}
                        </Dropdown.Toggle>

                        <Dropdown.Menu style={{ maxHeight: "300px", overflowY: "auto"}} id="dropdown-basic-button" >
                          {categoryList.map((item, index) => {
                            return (
                              <Dropdown.Item key={index} eventKey={item.id} className={classes.dropdown_item_wrap} onClick={() => onCategoryClick(item.id)}>
                                {item.code}
                              </Dropdown.Item>
                            );
                          })}
                        </Dropdown.Menu>
                      </Dropdown>
                    </Col>
                    <Col sm={3}>
                      <DropdownButton size="tiny_dropdown" variant="outline-secondary" id="dropdown-basic-button"
                        title={ !objAttrs.defaultLevel ? t("common:I18N_DROPDOWN_PROMPT") : t("custom:I18N_ALM_LVL_" + objAttrs.defaultLevel) }
                        onSelect={onDefaultLevelSelect}>
                        {defaultLevelOptions.map((item, index) => {
                          return (
                            <Dropdown.Item key={index} eventKey={item.key} className={classes.dropdown_item_wrap}>
                              {t("custom:I18N_ALM_LVL_" + item.value)}
                            </Dropdown.Item>
                          );
                        })}
                      </DropdownButton>
                    </Col>
                  </Row>

                  <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px' }}>
                    { configInfo.uiConfig.visibleFields.ALARMRULE_Class ?
                      <Col sm={3}>{t("I18N_Alarm_class")}: *</Col>
                    : null
                    }
                    <Col sm={3}>{t("I18N_Alarm_type")}: *</Col>
                    <Col sm={3}>{t("I18N_Alarm_impact_type")}: *</Col>
                    { configInfo.uiConfig.visibleFields.ALARMRULE_Sound ?
                      <Col sm={3}>{t("I18N_Alarm_sound")}:</Col>
                    : null
                    }
                  </Row>
                  <Row className={classes.admin_pages__field_value}>
                    { configInfo.uiConfig.visibleFields.ALARMRULE_Class ?
                      <Col sm={3}>
                        <DropdownButton size="tiny_dropdown" variant="outline-secondary" id="dropdown-basic-button"
                          title={ !objAttrs.class ? t("common:I18N_DROPDOWN_PROMPT") : t("common:I18N_" + objAttrs.class) }
                          onSelect={onClassSelect}>
                          {classOptions.map((item, index) => {
                            return (
                              <Dropdown.Item key={index} eventKey={item.key} className={classes.dropdown_item_wrap}>
                                {t("common:I18N_" + item.value)}
                              </Dropdown.Item>
                            );
                          })}
                        </DropdownButton>
                      </Col>
                      : null
                    }
                    <Col sm={3}>
                      {/* *** Allowing changing of type causes too much complication, therefore, user needs to create a new alarm rule with a different type.
                      <DropdownButton size="tiny_dropdown" variant="outline-secondary" id="dropdown-basic-button"
                        title={ !objAttrs.type ? t("common:I18N_DROPDOWN_PROMPT") : t("common:I18N_" + objAttrs.type) }
                        onSelect={onTypeSelect}>
                        {typeOptions.map((item, index) => {
                          return (
                            <Dropdown.Item key={index} eventKey={item.key} className={classes.dropdown_item_wrap}>
                              {t("common:I18N_" + item.value)}
                            </Dropdown.Item>
                          );
                        })}
                      </DropdownButton>
                      */}
                      {t("common:I18N_" + objAttrs.type)}
                    </Col>
                    <Col sm={3}>
                      <DropdownButton size="tiny_dropdown" variant="outline-secondary" id="dropdown-basic-button"
                        title={ !objAttrs.impactType ? t("common:I18N_DROPDOWN_PROMPT") : t("common:I18N_" + objAttrs.impactType) }
                        onSelect={onImpactTypeSelect}>
                        {impactTypeOptions.map((item, index) => {
                          return (
                            <Dropdown.Item key={index} eventKey={item.key} className={classes.dropdown_item_wrap}>
                              {t("common:I18N_" + item.value)}
                            </Dropdown.Item>
                          );
                        })}
                      </DropdownButton>
                    </Col>
                    { configInfo.uiConfig.visibleFields.ALARMRULE_Sound ?
                      <Col sm={3}>
                        <input readOnly className={classes.admin_pages__field_editable} style={{width:'80%'}} name="soundFile"
                               value={objAttrs.soundName ? objAttrs.soundName : ''}
                               />
                        <span onClick={handleSoundPicker} style={{ marginLeft:'10px', cursor: 'pointer', color: 'rgb(100,100,100)' }}>
                          <BiSearch size={14} />
                        </span>
                        <span onClick={handleSoundDelete} style={{ marginLeft:'3px', cursor: 'pointer', color: 'rgb(100,100,100)' }}>
                          <BiXCircle size={14} />
                        </span>
                      </Col>
                      : null
                    }
                  </Row>

                  <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px' }}>
                    { configInfo.uiConfig.visibleFields.ALARMRULE_AutoWorkorder ?
                      <Col sm={3}>{t("I18N_Alarm_auto_workorder")}:</Col>
                    : null
                    }
{/*
                    <Col sm={3}>{t("I18N_Broadcast_alarm")}:</Col>
*/}
                    <Col sm={3}>{t("I18N_Status")}: *</Col>
                    { objAttrs.status && (objAttrs.status === 'SUSPENDED') ?
                      <Col sm={3}>{t("I18N_Alarm_resume_time")}:</Col>
                    : null
                    }
                  </Row>
                  <Row className={classes.admin_pages__field_value}>
                    { configInfo.uiConfig.visibleFields.ALARMRULE_AutoWorkorder ?
                      <Col sm={3}><Form.Check type="switch" name={"autoWorkorder"} checked={objAttrs.autoWorkorder}
                           onChange={onCheckboxSelect} />
                      </Col>
                    : null
                    }
                    <Col sm={3}>
                      <DropdownButton size="tiny_dropdown" variant="outline-secondary" id="dropdown-basic-button"
                        title={ !objAttrs.status ? t("common:I18N_DROPDOWN_PROMPT") : t("common:I18N_" + objAttrs.status) }
                        onSelect={onStatusSelect}>
                        {statusOptions.map((item, index) => {
                          return (
                            <Dropdown.Item key={index} eventKey={item.key} className={classes.dropdown_item_wrap}>
                              {t("common:I18N_" + item.value)}
                            </Dropdown.Item>
                          );
                        })}
                      </DropdownButton>
                    </Col>
                    { objAttrs.status && (objAttrs.status === 'SUSPENDED') ?
                      <Col sm={3}>
                        <DateTimePicker onChange={onDatepickerChange} value={resumeTime ? resumeTime : ''}
                           format={ (resumeTime != null) ? "y-MM-dd h:00 a" : "y-MM-dd h:-- a" }
                           minDate={new Date(3600000 * ( Math.round(Date.now() / 3600000)))}
                           disableClock="true"
                           clearIcon=<BiXCircle size={16} style={{color:"gray"}}/>
                           calendarIcon=<BiCalendar size={16} style={{color:"gray"}}/>
                           locale={i18n.language === 'zh_HK' ? "zh-HK" : (i18n.language === 'zh_CN' ? "zh-CN" : "en")}
                        />
                      </Col>
                    : null
                    }
                  </Row>

                  <Row>
                    <div display='flex' style={{marginTop:'15px'}}>
                      <Button size="tiny" variant="outline-secondary" className="mb-3"
                        style={{ float: 'left' }}
                        onClick={handleEditGeneralCancel}>
                        {t("I18N_Cancel")}
                      </Button>
                      <Button size="tiny" variant="outline-secondary" className="mb-3"
                        style={{ marginLeft: '15px' }}
                        onClick={handleEditGeneralSubmit}>
                        {t("I18N_Save")}
                      </Button>
                      <span className={classes.admin_pages__field_label} style={{marginLeft:'30px', color:'rgba(200,0,0)', verticalAlign:'top'}}>
                        {errMsg_UpdateGeneral}
                      </span>
                    </div>
                  </Row>
                </form>
              </Container>
              :
              <Container>

                <Row className={classes.admin_pages__field_label}>
                  <Col sm={3}>{t("I18N_AlarmRule_code")}:</Col>
                  <Col sm={3}>{t("I18N_Description")}:</Col>
                  <Col sm={3}>{t("I18N_Alarm_category")}:</Col>
                  <Col sm={3}>{t("I18N_Default_level")}:</Col>
                </Row>
                <Row className={classes.admin_pages__field_value}>
                  <Col sm={3} style={{minWidth: '60px', flexWrap: 'wrap', wordWrap: 'break-word'}}>
                    {objAttrs.code}
                  </Col>
                  <Col sm={3} style={{maxHeight:'80px', overflow:'auto', flexWrap:'wrap', wordWrap:'break-word'}}>
                    {objAttrs.description}
                  </Col>
                  <Col sm={3} style={{minWidth: '60px', flexWrap: 'wrap', wordWrap: 'break-word'}}>
                    {(categoryList && objAttrs && objAttrs.categoryId) ?
                     categoryList.find( item => item.id.toString() === objAttrs.categoryId.toString()).code : null}
                  </Col>
                  <Col sm={3}>{t("custom:I18N_ALM_LVL_" + objAttrs.defaultLevel)}</Col>
                </Row>

                <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px' }}>
                  { configInfo.uiConfig.visibleFields.ALARMRULE_Class ?
                    <Col sm={3}>{t("I18N_Alarm_class")}:</Col>
                  : null
                  }
                  <Col sm={3}>{t("I18N_Alarm_type")}:</Col>
                  <Col sm={3}>{t("I18N_Alarm_impact_type")}:</Col>
                  { configInfo.uiConfig.visibleFields.ALARMRULE_Sound ?
                    <Col sm={3}>{t("I18N_Alarm_sound")}:</Col>
                  : null
                  }
                </Row>
                <Row className={classes.admin_pages__field_value}>
                  { configInfo.uiConfig.visibleFields.ALARMRULE_Class ?
                    <Col sm={3}>{t("common:I18N_" + objAttrs.class)}</Col>
                  : null
                  }
                  <Col sm={3}>{t("common:I18N_" + objAttrs.type)}</Col>
                  <Col sm={3}>{t("common:I18N_" + objAttrs.impactType)}</Col>
                  { configInfo.uiConfig.visibleFields.ALARMRULE_Sound ?
                    <Col sm={3}>{objAttrs.soundName ? objAttrs.soundName : "--"}</Col>
                  : null
                  }
                </Row>

                <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px' }}>
                  { configInfo.uiConfig.visibleFields.ALARMRULE_AutoWorkorder ?
                    <Col sm={3}>{t("I18N_Alarm_auto_workorder")}:</Col>
                  : null
                  }
{/*
                  <Col sm={3}>{t("I18N_Broadcast_alarm")}:</Col>
*/}
                  <Col sm={3}>{t("I18N_Status")}:</Col>
                  { objAttrs.status && (objAttrs.status === 'SUSPENDED') ?
                    <Col sm={3}>{t("I18N_Alarm_resume_time")}:</Col>
                  : null
                  }
                </Row>
                <Row className={classes.admin_pages__field_value}>
                  { configInfo.uiConfig.visibleFields.ALARMRULE_AutoWorkorder ?
                    <Col sm={3}>{objAttrs.autoWorkorder ? t("I18N_True") : t("I18N_False")}</Col>
                  : null
                  }
{/*
                  <Col sm={3}>{objAttrs.broadcast     ? t("I18N_True") : t("I18N_False")}</Col>
*/}
                  <Col sm={3}>{t("common:I18N_" + objAttrs.status)}</Col>
                  { objAttrs.status && (objAttrs.status === 'SUSPENDED') ?
                    <Col sm={3}>{objAttrs && objAttrs.resumeTime ?
                          formatDate(objAttrs.resumeTime) : t("I18N_No_resume_time")}</Col>
                  : null
                  }
                </Row>

                <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px' }}>
                  <Col sm={3}>{t("I18N_Created_by")}:</Col>
                  <Col sm={3}>{t("I18N_Time_created")}:</Col>
                  <Col sm={3}>{t("I18N_Updated_by")}:</Col>
                  <Col sm={3}>{t("I18N_Time_updated")}:</Col>
                </Row>
                <Row className={classes.admin_pages__field_value}>
                  <Col sm={3} style={{overflowWrap:'anywhere'}}>{objAttrs.creatorUsername}</Col>
                  <Col sm={3}>{formatDate(objAttrs.timeCreated)}</Col>
                  <Col sm={3} style={{overflowWrap:'anywhere'}}>{objAttrs.updaterUsername}</Col>
                  <Col sm={3}>{formatDate(objAttrs.timeUpdated)}</Col>
                </Row>
              </Container>
            }
          </div>


          { objAttrs && objAttrs.type === 'DERIVED' ?
            <div className={classes.admin_pages__page_subtitle} style={{marginTop:'20px'}}>
              <div display='flex'>
                <span>
                  {t("I18N_Trigger_logic")}
                </span>
                {editModeTriggerLogic ?
                  null
                  :
                  <span style={{marginLeft:'15px', fontSize:'9px', color:'SteelBlue', cursor:'pointer'}} onClick={handleEditTriggerLogic}>
                    <PencilIcon size={12} />
                    {t("I18N_Edit")}
                  </span>
                }
              </div>

              <hr className="solid" style={{ margin: '0 0 10px 0' }}></hr>

              {editModeTriggerLogic && triggerLogicAttrs ?
                <Container>
                  <form>

                    {/* ----- Applicable data and time ----- */}
                    <Row className={classes.admin_pages__field_value} style={{marginTop: '7px'}}>
                      <Col>{t("I18N_Applicable_day_time")}:</Col>
                    </Row>
                    <div style={{marginLeft: '0px', marginTop: '5px', border:'1px solid #AAA', borderRadius:'5px' }}>
                    <Row className={classes.admin_pages__field_value} style={{marginTop: '10px'}}>
                      <Col md={2}>
                        <Form.Check type="radio" name={"ANYTIME"} checked={(triggerLogicAttrs && triggerLogicAttrs.ANYTIME) ? triggerLogicAttrs.ANYTIME : false}
                                    label={t("I18N_Anytime")} onChange={onTriggerLogicCheckboxSelect} style={{marginLeft: '10px'}}/>
                      </Col>
                      <Col md={2}>
                        <div className='input-group'>
                          <Form.Check type="radio" name={"OFFICE_HR"} checked={(triggerLogicAttrs && triggerLogicAttrs.OFFICE_HR) ? triggerLogicAttrs.OFFICE_HR : false}
                                      label={t("custom:I18N_OFFICE_HR")} onChange={onTriggerLogicCheckboxSelect} style={{marginLeft: '10px'}}/>
                          <span style={{marginLeft:'5px'}} data-tooltip-id="tootip-office-hr1" data-tooltip-html={t("custom:I18N_OFFICE_HR_def_Tip")} >
                            <BiHelpCircle size={14} />
                          </span>
                          <Tooltip id="tootip-office-hr1" />
                        </div>
                      </Col>
                      <Col md={2}>
                        <div className='input-group'>
                          <Form.Check type="radio" name={"NONOFFICE_HR"} checked={(triggerLogicAttrs && triggerLogicAttrs.NONOFFICE_HR) ? triggerLogicAttrs.NONOFFICE_HR : false}
                                      label={t("custom:I18N_NONOFFICE_HR")} onChange={onTriggerLogicCheckboxSelect} style={{marginLeft: '10px'}} />
                          <span style={{marginLeft:'5px'}} data-tooltip-id="tootip-non-office-hr1" data-tooltip-html={t("custom:I18N_NONOFFICE_HR_def_Tip")} >
                            <BiHelpCircle size={14} />
                          </span>
                          <Tooltip id="tootip-non-office-hr1" />
                        </div>
                      </Col>
                      <Col md={2}>
                        <div className='input-group'>
                          <Form.Check type="radio" name={"BIZ_HR"} checked={(triggerLogicAttrs && triggerLogicAttrs.BIZ_HR) ? triggerLogicAttrs.BIZ_HR : false}
                                      label={t("custom:I18N_BIZ_HR")} onChange={onTriggerLogicCheckboxSelect} style={{marginLeft: '10px'}}/>
                          <span style={{marginLeft:'5px'}} data-tooltip-id="tootip-mall-hr1" data-tooltip-html={t("custom:I18N_BIZ_HR_def_Tip")} >
                            <BiHelpCircle size={14} />
                          </span>
                          <Tooltip id="tootip-mall-hr1" />
                        </div>
                      </Col>
                      <Col md={3}>
                        <div className='input-group'>
                          <Form.Check type="radio" name={"NONBIZ_HR"} checked={(triggerLogicAttrs && triggerLogicAttrs.NONBIZ_HR) ? triggerLogicAttrs.NONBIZ_HR : false}
                                      label={t("custom:I18N_NONBIZ_HR")} onChange={onTriggerLogicCheckboxSelect} style={{marginLeft: '10px'}} />
                          <span style={{marginLeft:'5px'}} data-tooltip-id="tootip-non-mall-hr1" data-tooltip-html={t("custom:I18N_NONBIZ_HR_def_Tip")} >
                            <BiHelpCircle size={14} />
                          </span>
                          <Tooltip id="tootip-non-mall-hr1" />
                        </div>
                      </Col>
{/*
                      <Col md={2}>
                        <Form.Check type="switch" name={"WD"} checked={triggerLogicAttrs.WD}
                                    label={t("I18N_Weekdays")} onChange={onTriggerLogicCheckboxSelect} style={{marginLeft: '10px'}} />
                      </Col>
                      <Col md={2}>
                        <Form.Check type="switch" name={"WE"} checked={triggerLogicAttrs.WE}
                                    label={t("I18N_Weekend")} onChange={onTriggerLogicCheckboxSelect} style={{marginLeft: '10px'}} />
                      </Col>
                      <Col md={2}>
                        <Form.Check type="switch" name={"HOL"} checked={triggerLogicAttrs.HOL}
                                    label={t("I18N_Holidays")} onChange={onTriggerLogicCheckboxSelect} style={{marginLeft: '10px'}} />
                      </Col>
*/}
                    </Row>
                    </div>

                    <Row className={classes.admin_pages__field_value} style={{marginTop: '15px'}}>
                      <Col md={2}>
                        <Form.Check type="switch" name={"useOccCnt"}
                           checked={triggerLogicAttrs ? triggerLogicAttrs.useOccCnt : false}
                           label={t("I18N_Occur_count")} onChange={onTriggerLogicCheckboxSelect} />
                      </Col>
                      <Col md={2}>
{/*
                        <input type='number' min={2} className={classes.admin_pages__field_editable} style={{width:'100%'}} name="occCnt"
*/}
                        <input className={classes.admin_pages__field_editable} style={{width:'100%'}} name="occCnt"
                          disabled={!triggerLogicAttrs || !triggerLogicAttrs.useOccCnt}
                          value={(triggerLogicAttrs && triggerLogicAttrs.occCnt) ? triggerLogicAttrs.occCnt : ''}
                          onChange={(e) => onTriggerLogicAttrsInputChange(e)} />
                      </Col>
                      <Col md={2}> {t("I18N_Within_time_window")} </Col>
                      <Col md={2}>
                        <input className={classes.admin_pages__field_editable} name="timeWindow"
                          disabled={!triggerLogicAttrs || !triggerLogicAttrs.useOccCnt}
                          value={(triggerLogicAttrs && triggerLogicAttrs.timeWindow) ? triggerLogicAttrs.timeWindow : ''}
                          onChange={(e) => onTriggerLogicAttrsInputChange(e)} />
                      </Col>
                      <Col md={2}>
                        <DropdownButton size="tiny_dropdown" variant="outline-secondary" id="dropdown-basic-button"
                          title={(!triggerLogicAttrs || !triggerLogicAttrs.timeWinUnit) ? t("common:I18N_Prompt_time_unit") : t("I18N_Time_unit_" + triggerLogicAttrs.timeWinUnit)}
                          onSelect={onTimeWinUnitSelect}>
                          {timeWinUnitOptions.map((item, index) => {
                            return (
                              <Dropdown.Item key={index} eventKey={item.key} className={classes.dropdown_item_wrap}>
                                {t("I18N_Time_unit_" + item.value)}
                              </Dropdown.Item>
                            );
                          })}
                        </DropdownButton>
                      </Col>
                      <Col md={3}>
                      </Col>
                    </Row>

                    <Row className={classes.admin_pages__field_value} style={{marginTop: '5px'}}>
                      <Col md={2}>
                        <Form.Check type="switch" name={"useOccDur"} checked={triggerLogicAttrs.useOccDur}
                                    label={t("I18N_Occur_duration")} onChange={onTriggerLogicCheckboxSelect} />
                      </Col>
                      <Col md={2}>
                        <input className={classes.admin_pages__field_editable} style={{width:'100%'}} name="occDur"
                          disabled={!triggerLogicAttrs || !triggerLogicAttrs.useOccDur}
                          value={triggerLogicAttrs.occDur ? triggerLogicAttrs.occDur : ''}
                          onChange={(e) => onTriggerLogicAttrsInputChange(e)} />
                      </Col>
                      <Col md={8}></Col>
                    </Row>

                    {/* ----- Data scope ----- */}
                    <Row className={classes.admin_pages__field_value} style={{marginTop: '7px'}}>
                      <Col>{t("I18N_Data_scope")}:</Col>
                    </Row>
                    <div style={{marginLeft: '0px', marginTop: '5px', border:'1px solid #AAA', borderRadius:'5px' }}>
                      <Row className={classes.admin_pages__field_value} style={{marginTop: '10px'}}>
                        <Col md={2}>
                          <Form.Check type="radio" name={"SCOPE_DP_TYPE"} checked={triggerLogicAttrs && triggerLogicAttrs.scope && (triggerLogicAttrs.scope === "SCOPE_DP_TYPE") }
                                      label={t("I18N_Datapoint_type")}     onChange={onTriggerLogicCheckboxSelect} style={{marginLeft: '10px'}}/>
                        </Col>
                        <Col md={2}>
                          <Form.Check type="radio" name={"SCOPE_DP"}      checked={triggerLogicAttrs && triggerLogicAttrs.scope && (triggerLogicAttrs.scope === "SCOPE_DP") }
                                      label={t("I18N_Datapoint")}          onChange={onTriggerLogicCheckboxSelect} style={{marginLeft: '10px'}}/>
                        </Col>
                      </Row>
                    </div>

                    <Row className={classes.admin_pages__field_value} style={{marginTop: '7px'}}>
                      <Col>{t("I18N_Data_value_conditions")}:</Col>
                    </Row>

                    {/* ----- Condition Group 1 ----- */}

                    <div style={{marginLeft: '0px', marginTop: '5px', padding:'10px', border:'1px solid #AAA', borderRadius:'5px' }}>
                      { !triggerLogicAttrs.useOccCnt || (triggerLogicAttrs.useOccCnt !== true) ?
                      <Row className={classes.admin_pages__field_label} >
                        <span style={{marginLeft:'2px', marginBottom:'5px', fontSize:'13px', textDecorationLine: 'underline'}} >{t("I18N_Cond_group_1")}</span>
                      </Row>
                      : null
                      }

                      {/* ----- Condition Group 1 - Condition 1 ----- */}

                      <Row className={classes.admin_pages__field_label} >
                        { !triggerLogicAttrs.useOccCnt || (triggerLogicAttrs.useOccCnt !== true) ?
                        <Col md={1}></Col>
                        : null
                        }
                        <Col md={5}>{ triggerLogicAttrs && (triggerLogicAttrs.scope === 'SCOPE_DP_TYPE') ?  t("I18N_Datapoint_type_code") : t("I18N_Datapoint_code")}:</Col>
                        <Col md={2}>
                          {t("I18N_Operator")}:
                          { configInfo.uiConfig.visibleFields.ALARMRULE_LogicOpTip ?
                            <>
                              <span style={{marginLeft:'5px'}} data-tooltip-id="tootip-operators" data-tooltip-html={t("I18N_TIP_Ops")} >
                                <BiHelpCircle size={14} />
                              </span>
                              <Tooltip id="tootip-operators" />
                            </>
                          : null
                          }
                        </Col>

                        { triggerLogicAttrs.condGrp1 && triggerLogicAttrs.condGrp1.cond1 && triggerLogicAttrs.condGrp1.cond1.op && triggerLogicAttrs.condGrp1.cond1.op === 'EXISTS' ? null
                        :
                        <Col md={2}>{t("I18N_Operand")}:</Col>
                        }
                        <Col md={2}></Col>
                      </Row>

                      <Row className={classes.admin_pages__field_value} style={{display:'flex'}}>
                        { !triggerLogicAttrs.useOccCnt || (triggerLogicAttrs.useOccCnt !== true) ?
                          <Col md={1}>{t("I18N_Cond_1")}:</Col>
                        : null
                        }
                        <Col md={5} style={{display:'flex'}}>
                          <input readOnly className={classes.admin_pages__field_editable} style={{width:'100%'}} name="cond1.dp"
                            value={(triggerLogicAttrs && triggerLogicAttrs.condGrp1 && triggerLogicAttrs.condGrp1.cond1) ? triggerLogicAttrs.condGrp1.cond1.dp : ''} />
                          <span onClick={() => handleDataPicker('DATAPOINT1')} style={{ marginLeft:'10px', cursor: 'pointer', color: 'rgb(100,100,100)' }}>
                            <BiSearch size={14} />
                          </span>
                        </Col>
                        <Col md={2}>
                          <DropdownButton size="tiny_dropdown" variant="outline-secondary" id="dropdown-basic-button"
                            title={ (!triggerLogicAttrs || !triggerLogicAttrs.condGrp1 || !triggerLogicAttrs.condGrp1.cond1 || !triggerLogicAttrs.condGrp1.cond1.op)
                                    ? t("common:I18N_DROPDOWN_PROMPT") :
                                    opOptions.find( item => item.key === triggerLogicAttrs.condGrp1.cond1.op).value}
                            onSelect={onOperator1Select}>
                            {opOptions.map((item, index) => {
                              return (
                                <Dropdown.Item key={index} eventKey={item.key} className={classes.dropdown_item_wrap}>
                                  {item.value}
                                </Dropdown.Item>
                              );
                            })}
                          </DropdownButton>
                        </Col>
                        { triggerLogicAttrs.condGrp1 && triggerLogicAttrs.condGrp1.cond1 && triggerLogicAttrs.condGrp1.cond1.op && triggerLogicAttrs.condGrp1.cond1.op === 'EXISTS' ? null
                        :
                        <Col md={2}>
                          <input className={classes.admin_pages__field_editable} style={{width:'100%'}} name="value1"
                            value={(triggerLogicAttrs && triggerLogicAttrs.condGrp1 && triggerLogicAttrs.condGrp1.cond1) ? triggerLogicAttrs.condGrp1.cond1.value : ''}
                            onChange={(e) => onTriggerLogicAttrsInputChange(e)} />
                        </Col>
                        }
                        <Col md={1}>
                          <span style={{cursor:'pointer', color:'SteelBlue'}}
                            onClick={() => handleDeleteCond('CONDITION1')}><BiTrash size={16} />
                          </span>
                        </Col>
                        <Col md={1}></Col>
                      </Row>

                      {/* ----- Condition Group 1 - Logic Operator ----- */}

                      { !triggerLogicAttrs.useOccCnt || (triggerLogicAttrs.useOccCnt !== true) ?
                      <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px' }}>
                        <Col>
                          <DropdownButton size="tiny_dropdown" variant="outline-secondary" id="dropdown-basic-button"
                            title={ (!triggerLogicAttrs.condGrp1 || !triggerLogicAttrs.condGrp1.condOp1) ? t("common:I18N_DROPDOWN_PROMPT") :
                                    andOrOptions.find( item => item.key === triggerLogicAttrs.condGrp1.condOp1).value}
                            onSelect={onDpLogicOp1Select}>
                            {andOrOptions.map((item, index) => {
                              return (
                                <Dropdown.Item key={index} eventKey={item.key} className={classes.dropdown_item_wrap}>
                                  {item.value}
                                </Dropdown.Item>
                              );
                            })}
                          </DropdownButton>
                        </Col>
                      </Row>
                      : null
                      }

                      { triggerLogicAttrs.condGrp1 && triggerLogicAttrs.condGrp1.condOp1 && (triggerLogicAttrs.condGrp1.condOp1 !== 'None') && (triggerLogicAttrs.useOccCnt !== true) ?
                      <>

                      {/* ----- Condition Group 1 - Condition 2 ----- */}

                      <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px' }}>
                        <Col md={1}></Col>
                        <Col md={5}>{  triggerLogicAttrs && (triggerLogicAttrs.scope === 'SCOPE_DP_TYPE') ?  t("I18N_Datapoint_type_code") : t("I18N_Datapoint_code")}:</Col>
                        <Col md={2}>
                          {t("I18N_Operator")}:
                          { configInfo.uiConfig.visibleFields.ALARMRULE_LogicOpTip ?
                            <>
                              <span style={{marginLeft:'5px'}} data-tooltip-id="tootip-operators" data-tooltip-html={t("I18N_TIP_Ops")} >
                                <BiHelpCircle size={14} />
                              </span>
                              <Tooltip id="tootip-operators" />
                            </>
                          : null
                          }
                        </Col>

                        { triggerLogicAttrs.condGrp1 && triggerLogicAttrs.condGrp1.cond2 && triggerLogicAttrs.condGrp1.cond2.op && triggerLogicAttrs.condGrp1.cond2.op === 'EXISTS' ? null
                        :
                        <Col md={2}>{t("I18N_Operand")}:</Col>
                        }
                        <Col md={2}></Col>
                      </Row>

                      <Row className={classes.admin_pages__field_value}>
                        <Col md={1}>{t("I18N_Cond_2")}:</Col>
                        <Col md={5} style={{display:'flex'}}>
                          <input readOnly className={classes.admin_pages__field_editable} style={{width:'100%'}} name="cond2.dp"
                            value={(triggerLogicAttrs && triggerLogicAttrs.condGrp1 && triggerLogicAttrs.condGrp1.cond2) ? triggerLogicAttrs.condGrp1.cond2.dp : ''} />

                          { triggerLogicAttrs.scope === 'SCOPE_DP' ?
                            <span onClick={() => handleDataPicker('DATAPOINT2')} style={{ marginLeft:'10px', cursor: 'pointer', color: 'rgb(100,100,100)' }}>
                              <BiSearch size={14} />
                            </span>
                          :
                            <span style={{ marginLeft:'23px' }}>
                              {' '}
                            </span>
                          }
                        </Col>
                        <Col md={2}>
                          <DropdownButton size="tiny_dropdown" variant="outline-secondary" id="dropdown-basic-button"
                            title={ (!triggerLogicAttrs || !triggerLogicAttrs.condGrp1 || !triggerLogicAttrs.condGrp1.cond2 || !triggerLogicAttrs.condGrp1.cond2.op)
                                    ? t("common:I18N_DROPDOWN_PROMPT") :
                                    opOptions.find( item => item.key === triggerLogicAttrs.condGrp1.cond2.op).value}
                            onSelect={onOperator2Select}>
                            {opOptions.map((item, index) => {
                              return (
                                <Dropdown.Item key={index} eventKey={item.key} className={classes.dropdown_item_wrap}>
                                  {item.value}
                                </Dropdown.Item>
                              );
                            })}
                          </DropdownButton>
                        </Col>

                        { triggerLogicAttrs.condGrp1 && triggerLogicAttrs.condGrp1.cond2 && triggerLogicAttrs.condGrp1.cond2.op && triggerLogicAttrs.condGrp1.cond2.op === 'EXISTS' ? null
                        :
                        <Col md={2}>
                          <input className={classes.admin_pages__field_editable} style={{width:'100%'}} name="value2"
                            value={(triggerLogicAttrs && triggerLogicAttrs.condGrp1 && triggerLogicAttrs.condGrp1.cond2) ? triggerLogicAttrs.condGrp1.cond2.value : ''}
                            onChange={(e) => onTriggerLogicAttrsInputChange(e)} />
                        </Col>
                        }

                        <Col md={1}>
                          <span style={{cursor:'pointer', color:'SteelBlue'}}
                            onClick={() => handleDeleteCond('CONDITION2')}><BiTrash size={16} />
                          </span>
                        </Col>
                        <Col md={1}></Col>
                      </Row>
                      </>
                      : null
                      }
                    </div>

                    {/* ----- Condition Group 1 - END ----- */}

                    {/* ----- Connection to Condition Group 2 ----- */}

                    { !triggerLogicAttrs.useOccCnt || (triggerLogicAttrs.useOccCnt !== true) ?
                      <div style={{padding:'5px 5px 5px 0px' }}>
                        { !triggerLogicAttrs.condGrp2 ?
                          <Button size="tiny" variant="outline-secondary"
                            onClick={handleAddCondGrp2}>
                            {t("I18N_Add_Cond_Group_2")}
                          </Button>
                        :
                          <>
                            <span>
                             {'[ ' + t("custom:I18N_LogicalOp_AND") + ' ]'}
                            </span>
                            <Button size="tiny" variant="outline-secondary"
                              style={{marginLeft: '20px'}}
                              onClick={handleRemoveCondGrp2}>
                              {t("I18N_Remove_Cond_Group_2")}
                            </Button>
                          </>
                        }
                      </div>
                    : null
                    }

                    {/* ----- Condition Group 2 ----- */}

                    { triggerLogicAttrs.condGrp2 && (!triggerLogicAttrs.useOccCnt || (triggerLogicAttrs.useOccCnt !== true)) ?
                    <div style={{padding:'10px', border:'1px solid #AAA', borderRadius:'5px' }}>
                      <Row className={classes.admin_pages__field_label} >
                        <span style={{marginLeft:'2px', marginBottom:'5px', fontSize:'13px', textDecorationLine: 'underline'}} >{t("I18N_Cond_group_2")}</span>
                      </Row>

                      {/* ----- Condition Group 2 - Condition 3 ----- */}

                      <Row className={classes.admin_pages__field_label} >
                        <Col md={1}></Col>
                        <Col md={5}>{  triggerLogicAttrs && (triggerLogicAttrs.scope === 'SCOPE_DP_TYPE') ?  t("I18N_Datapoint_type_code") : t("I18N_Datapoint_code")}:</Col>
                        <Col md={2}>
                          {t("I18N_Operator")}:
                          { configInfo.uiConfig.visibleFields.ALARMRULE_LogicOpTip ?
                            <>
                              <span style={{marginLeft:'5px'}} data-tooltip-id="tootip-operators" data-tooltip-html={t("I18N_TIP_Ops")} >
                                <BiHelpCircle size={14} />
                              </span>
                              <Tooltip id="tootip-operators" />
                            </>
                          : null
                          }
                        </Col>
                        { triggerLogicAttrs.condGrp2 && triggerLogicAttrs.condGrp2.cond3 && triggerLogicAttrs.condGrp2.cond3.op && triggerLogicAttrs.condGrp2.cond3.op === 'EXISTS' ? null
                        :
                        <Col md={2}>{t("I18N_Operand")}:</Col>
                        }
                        <Col md={2}></Col>
                      </Row>

                      <Row className={classes.admin_pages__field_value} style={{display:'flex'}}>
                        <Col md={1}>{t("I18N_Cond_3")}:</Col>
                        <Col md={5} style={{display:'flex'}}>
                          <input readOnly className={classes.admin_pages__field_editable} style={{width:'100%'}} name="cond3.dp"
                            value={(triggerLogicAttrs && triggerLogicAttrs.condGrp2 && triggerLogicAttrs.condGrp2.cond3) ? triggerLogicAttrs.condGrp2.cond3.dp : ''} />

                          { triggerLogicAttrs.scope === 'SCOPE_DP' ?
                            <span onClick={() => handleDataPicker('DATAPOINT3')} style={{ marginLeft:'10px', cursor: 'pointer', color: 'rgb(100,100,100)' }}>
                              <BiSearch size={14} />
                            </span>
                          :
                            <span style={{ marginLeft:'23px' }}>
                              {' '}
                            </span>
                          }
                        </Col>
                        <Col md={2}>
                          <DropdownButton size="tiny_dropdown" variant="outline-secondary" id="dropdown-basic-button"
                            title={ (!triggerLogicAttrs || !triggerLogicAttrs.condGrp2 || !triggerLogicAttrs.condGrp2.cond3 || !triggerLogicAttrs.condGrp2.cond3.op)
                                    ? t("common:I18N_DROPDOWN_PROMPT") :
                                    opOptions.find( item => item.key === triggerLogicAttrs.condGrp2.cond3.op).value}
                            onSelect={onOperator3Select}>
                            {opOptions.map((item, index) => {
                              return (
                                <Dropdown.Item key={index} eventKey={item.key} className={classes.dropdown_item_wrap}>
                                  {item.value}
                                </Dropdown.Item>
                              );
                            })}
                          </DropdownButton>
                        </Col>
                        { triggerLogicAttrs.condGrp2 && triggerLogicAttrs.condGrp2.cond3 && triggerLogicAttrs.condGrp2.cond3.op && triggerLogicAttrs.condGrp2.cond3.op === 'EXISTS' ? null
                        :
                        <Col md={2}>
                          <input className={classes.admin_pages__field_editable} style={{width:'100%'}} name="value3"
                            value={(triggerLogicAttrs && triggerLogicAttrs.condGrp2 && triggerLogicAttrs.condGrp2.cond3) ? triggerLogicAttrs.condGrp2.cond3.value : ''}
                            onChange={(e) => onTriggerLogicAttrsInputChange(e)} />
                        </Col>
                        }
                        <Col md={1}>
                          <span style={{cursor:'pointer', color:'SteelBlue'}}
                            onClick={() => handleDeleteCond('CONDITION3')}><BiTrash size={16} />
                          </span>
                        </Col>
                        <Col md={1}></Col>
                      </Row>

                      {/* ----- Condition Group 2 - Logic Operator ----- */}

                      <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px' }}>
                        <Col>
                          <DropdownButton size="tiny_dropdown" variant="outline-secondary" id="dropdown-basic-button"
                            title={ (!triggerLogicAttrs.condGrp2 || !triggerLogicAttrs.condGrp2.condOp2) ? t("common:I18N_DROPDOWN_PROMPT") :
                                    andOrOptions.find( item => item.key === triggerLogicAttrs.condGrp2.condOp2).value}
                            onSelect={onDpLogicOp2Select}>
                            {andOrOptions.map((item, index) => {
                              return (
                                <Dropdown.Item key={index} eventKey={item.key} className={classes.dropdown_item_wrap}>
                                  {item.value}
                                </Dropdown.Item>
                              );
                            })}
                          </DropdownButton>
                        </Col>
                      </Row>

                      {/* ----- Condition Group 2 - Condition 4 ----- */}

                      {  triggerLogicAttrs.condGrp2 && triggerLogicAttrs.condGrp2.condOp2 && (triggerLogicAttrs.condGrp2.condOp2 !== 'None') ?
                      <>
                      <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px' }}>
                        <Col md={1}></Col>
                        <Col md={5}>{  triggerLogicAttrs && (triggerLogicAttrs.scope === 'SCOPE_DP_TYPE') ?  t("I18N_Datapoint_type_code") : t("I18N_Datapoint_code")}:</Col>
                        <Col md={2}>
                          {t("I18N_Operator")}:
                          { configInfo.uiConfig.visibleFields.ALARMRULE_LogicOpTip ?
                            <>
                              <span style={{marginLeft:'5px'}} data-tooltip-id="tootip-operators" data-tooltip-html={t("I18N_TIP_Ops")} >
                                <BiHelpCircle size={14} />
                              </span>
                              <Tooltip id="tootip-operators" />
                            </>
                          : null
                          }
                        </Col>
                        { triggerLogicAttrs.condGrp2 && triggerLogicAttrs.condGrp2.cond4 && triggerLogicAttrs.condGrp2.cond4.op && triggerLogicAttrs.condGrp2.cond4.op === 'EXISTS' ? null
                        :
                        <Col md={2}>{t("I18N_Operand")}:</Col>
                        }
                        <Col md={2}></Col>
                      </Row>
                      <Row className={classes.admin_pages__field_value}>
                        <Col md={1}>{t("I18N_Cond_4")}:</Col>
                        <Col md={5} style={{display:'flex'}}>
                          <input readOnly className={classes.admin_pages__field_editable} style={{width:'100%'}} name="cond4.dp"
                            value={(triggerLogicAttrs && triggerLogicAttrs.condGrp2.cond4) ? triggerLogicAttrs.condGrp2.cond4.dp : ''} />

                          { triggerLogicAttrs.scope === 'SCOPE_DP' ?
                            <span onClick={() => handleDataPicker('DATAPOINT4')} style={{ marginLeft:'10px', cursor: 'pointer', color: 'rgb(100,100,100)' }}>
                              <BiSearch size={14} />
                            </span>
                          :
                            <span style={{ marginLeft:'23px' }}>
                              {' '}
                            </span>
                          }
{/*
                          <span style={{ marginLeft:'23px' }}>
                            {' '}
                          </span>
*/}
                        </Col>
                        <Col md={2}>
                          <DropdownButton size="tiny_dropdown" variant="outline-secondary" id="dropdown-basic-button"
                            title={  (!triggerLogicAttrs || !triggerLogicAttrs.condGrp2.cond4 || !triggerLogicAttrs.condGrp2.cond4.op) ? t("common:I18N_DROPDOWN_PROMPT") :
                                    opOptions.find( item => item.key === triggerLogicAttrs.condGrp2.cond4.op).value}
                            onSelect={onOperator4Select}>
                            {opOptions.map((item, index) => {
                              return (
                                <Dropdown.Item key={index} eventKey={item.key} className={classes.dropdown_item_wrap}>
                                  {item.value}
                                </Dropdown.Item>
                              );
                            })}
                          </DropdownButton>
                        </Col>
                        { triggerLogicAttrs.condGrp2 && triggerLogicAttrs.condGrp2.cond4 && triggerLogicAttrs.condGrp2.cond4.op && triggerLogicAttrs.condGrp2.cond4.op === 'EXISTS' ? null
                        :
                        <Col md={2}>
                          <input className={classes.admin_pages__field_editable} style={{width:'100%'}} name="value4"
                            value={(triggerLogicAttrs && triggerLogicAttrs.condGrp2.cond4) ? triggerLogicAttrs.condGrp2.cond4.value : ''}
                            onChange={(e) => onTriggerLogicAttrsInputChange(e)} />
                        </Col>
                        }
                        <Col md={1}>
                          <span style={{cursor:'pointer', color:'SteelBlue'}}
                            onClick={() => handleDeleteCond('CONDITION4')}><BiTrash size={16} />
                          </span>
                        </Col>
                        <Col md={1}></Col>
                      </Row>
                      </>
                      : null
                      }
                    </div>
                    : null
                    }

                    {/* ----- Condition Group 2 - END ----- */}

                    <Row>
                      <div display='flex' style={{marginTop:'20px'}}>
                        <Button size="tiny" variant="outline-secondary" className="mb-3"
                          style={{ float: 'left' }}
                          onClick={handleEditTriggerLogicCancel}>
                          {t("I18N_Cancel")}
                        </Button>
                        <Button size="tiny" variant="outline-secondary" className="mb-3"
                          style={{ marginLeft: '15px' }}
                          onClick={handleEditTriggerLogicSubmit}>
                          {t("I18N_Save")}
                        </Button>
                        <span className={classes.admin_pages__field_label} style={{marginLeft:'30px', color:'rgba(200,0,0)', verticalAlign:'top'}}>
                          {errMsg_UpdateTriggerLogic}
                        </span>
                      </div>
                    </Row>
                  </form>
                </Container>
                :
                <Container>
                {
                  triggerLogicAttrs && triggerLogicAttrs.condGrp1 /* ===== Viewing Mode (if defined) ===== */ ?
                    <>
                      <Row className={classes.admin_pages__field_value} style={{marginTop: '7px'}}>
                        <Col>{t("I18N_Applicable_day_time")}:</Col>
                      </Row>
                      <Row className={classes.admin_pages__field_value} style={{marginTop: '10px'}}>
                        <Col md={12}>
                          { (triggerLogicAttrs && triggerLogicAttrs.ANYTIME) ?
                            <span><BiCheckSquare size={16} style={{marginTop:'-3px', marginRight:'2px'}}/></span>
                          :
                            <span><BiRectangle size={16} style={{marginTop:'-3px', marginRight:'2px'}}/></span>
                          }
                          <span>{t("I18N_Anytime")}</span>

                          { (triggerLogicAttrs && triggerLogicAttrs.OFFICE_HR) ?
                            <span style={{marginLeft:'20px'}}><BiCheckSquare size={16} style={{marginTop:'-3px', marginRight:'2px'}}/></span>
                          :
                            <span style={{marginLeft:'20px'}}><BiRectangle size={16} style={{marginTop:'-3px', marginRight:'2px'}}/></span>
                          }
                          <span>{t("custom:I18N_OFFICE_HR")}</span>
                          <span style={{marginLeft:'5px'}} data-tooltip-id="tooltip-office-hr2" data-tooltip-html={t("custom:I18N_OFFICE_HR_def_Tip")} >
                            <BiHelpCircle size={14} />
                          </span>
                          <Tooltip id="tooltip-office-hr2" />

                          { (triggerLogicAttrs && triggerLogicAttrs.NONOFFICE_HR) ?
                            <span style={{marginLeft:'20px'}}><BiCheckSquare size={16} style={{marginTop:'-3px', marginRight:'2px'}}/></span>
                          :
                            <span style={{marginLeft:'20px'}}><BiRectangle size={16} style={{marginTop:'-3px', marginRight:'2px'}}/></span>
                          }
                          <span>{t("custom:I18N_NONOFFICE_HR")}</span>
                          <span style={{marginLeft:'5px'}} data-tooltip-id="tooltip-non-office-hr2" data-tooltip-html={t("custom:I18N_NONOFFICE_HR_def_Tip")} >
                            <BiHelpCircle size={14} />
                          </span>
                          <Tooltip id="tooltip-non-office-hr2" />

                          { (triggerLogicAttrs && triggerLogicAttrs.BIZ_HR) ?
                              <span style={{marginLeft:'20px'}}><BiCheckSquare size={16} style={{marginTop:'-3px', marginRight:'2px'}}/></span>
                            :
                              <span style={{marginLeft:'20px'}}><BiRectangle size={16} style={{marginTop:'-3px', marginRight:'2px'}}/></span>
                          }
                          <span>{t("custom:I18N_BIZ_HR")}</span>
                          <span style={{marginLeft:'5px'}} data-tooltip-id="tooltip-mall-hr2" data-tooltip-html={t("custom:I18N_BIZ_HR_def_Tip")} >
                            <BiHelpCircle size={14} />
                          </span>
                          <Tooltip id="tooltip-mall-hr2" />

                          { (triggerLogicAttrs && triggerLogicAttrs.NONBIZ_HR) ?
                              <span style={{marginLeft:'20px'}}><BiCheckSquare size={16} style={{marginTop:'-3px', marginRight:'2px'}}/></span>
                            :
                              <span style={{marginLeft:'20px'}}><BiRectangle size={16} style={{marginTop:'-3px', marginRight:'2px'}}/></span>
                          }
                          <span>{t("custom:I18N_NONBIZ_HR")}</span>
                          <span style={{marginLeft:'5px'}} data-tooltip-id="tooltip-non-mall-hr2" data-tooltip-html={t("custom:I18N_NONBIZ_HR_def_Tip")} >
                            <BiHelpCircle size={14} />
                          </span>
                          <Tooltip id="tooltip-non-mall-hr2" />

{/*
                          { (triggerLogicAttrs && triggerLogicAttrs.WD) ?
                            <>
                              <span><BiCheckSquare size={16} style={{marginTop:'-3px', marginRight:'2px'}}/></span>
                              <span style={{marginRight:'20px'}}>{t("I18N_Weekdays")}</span>
                            </>
                          :
                            <>
                              <span><BiRectangle size={16} style={{marginTop:'-3px', marginRight:'2px'}}/></span>
                              <span style={{marginRight:'20px'}}>{t("I18N_Weekdays")}</span>
                            </>
                          }
                          { (triggerLogicAttrs && triggerLogicAttrs.WE) ?
                            <>
                              <span><BiCheckSquare size={16} style={{marginTop:'-3px', marginRight:'2px'}}/></span>
                              <span style={{marginRight:'20px'}}>{t("I18N_Weekend")}</span>
                            </>
                          :
                            <>
                              <span><BiRectangle size={16} style={{marginTop:'-3px', marginRight:'2px'}}/></span>
                              <span style={{marginRight:'20px'}}>{t("I18N_Weekdays")}</span>
                            </>
                          }
                          { (triggerLogicAttrs && triggerLogicAttrs.HOL) ?
                            <>
                              <span><BiCheckSquare size={16} style={{marginTop:'-3px', marginRight:'2px'}}/></span>
                              <span style={{marginRight:'20px'}}>{t("I18N_Holidays")}</span>
                            </>
                          :
                            <>
                              <span><BiRectangle size={16} style={{marginTop:'-3px', marginRight:'2px'}}/></span>
                              <span style={{marginRight:'20px'}}>{t("I18N_Holidays")}</span>
                            </>
                          }
*/}
                        </Col>
                      </Row>

                      { triggerLogicAttrs.useOccCnt ?
                          <Row className={classes.admin_pages__field_value} style={{marginTop: '15px'}}>
                            <Col md={12}>
                              <span>{t("I18N_Occur_count") + ": "}</span>
                              <span style={{marginLeft:'5px'}}>{triggerLogicAttrs.occCnt}</span>
                              <span style={{marginLeft:'10px'}}>{t("I18N_Within_time_window")}:</span>
                              <span style={{marginLeft:'5px'}}>{triggerLogicAttrs.timeWindow}</span>
                              <span style={{marginLeft:'5px'}}>{t("I18N_Time_unit_" + triggerLogicAttrs.timeWinUnit)}</span>
                            </Col>
                          </Row>
                      : null
                      }

                      { triggerLogicAttrs.useOccDur ?
                          <Row className={classes.admin_pages__field_value} style={{marginTop: '5px'}}>
                           <Col md={2}> {t("I18N_Occur_duration") + ": "} </Col>
                           <Col md={2}> {triggerLogicAttrs.occDur} </Col>
                           <Col md={8}></Col>
                         </Row>
                      : null
                      }

                      <Row className={classes.admin_pages__field_value} style={{marginTop: '7px'}}>
                        <Col>{t("I18N_Data_scope")}:</Col>
                      </Row>
                      <Row className={classes.admin_pages__field_value} style={{marginTop: '10px'}}>
                        <Col md={12}>
                          { (triggerLogicAttrs && triggerLogicAttrs.scope === 'SCOPE_DP_TYPE') ?
                            <span><BiCheckSquare size={16} style={{marginTop:'-3px', marginRight:'2px'}}/></span>
                          :
                            <span><BiRectangle size={16} style={{marginTop:'-3px', marginRight:'2px'}}/></span>
                          }
                          <span>{t("I18N_Datapoint_type")}</span>

                          { (triggerLogicAttrs && triggerLogicAttrs.scope === 'SCOPE_DP') ?
                            <span style={{marginLeft:'20px'}}><BiCheckSquare size={16} style={{marginTop:'-3px', marginRight:'2px'}}/></span>
                          :
                            <span style={{marginLeft:'20px'}}><BiRectangle size={16} style={{marginTop:'-3px', marginRight:'2px'}}/></span>
                          }
                          <span>{t("I18N_Datapoint")}</span>
                        </Col>
                      </Row>

                      <Row className={classes.admin_pages__field_value} style={{marginTop: '7px'}}>
                        <Col>{t("I18N_Data_value_conditions")}:</Col>
                      </Row>

                      <div style={{marginLeft: '10px', marginTop: '5px', padding:'10px', border:'1px solid #AAA', borderRadius:'5px' }}>

                        <Row className={classes.admin_pages__field_value} style={{display:'flex'}}>
                          <Col md={12} style={{display:'flex'}}>
                            <span>
                              {(triggerLogicAttrs && triggerLogicAttrs.condGrp1 && triggerLogicAttrs.condGrp1.cond1) ?  triggerLogicAttrs.condGrp1.cond1.dp : ''}
                            </span>
                            <span style={{marginLeft:'10px',marginRight:'10px'}}>
                              {(triggerLogicAttrs && triggerLogicAttrs.condGrp1 && triggerLogicAttrs.condGrp1.cond1 && triggerLogicAttrs.condGrp1.cond1.op) ?
                               opOptions.find( item => item.key === triggerLogicAttrs.condGrp1.cond1.op).value : ''}
                            </span>
                            <span>
                              {(triggerLogicAttrs && triggerLogicAttrs.condGrp1 && triggerLogicAttrs.condGrp1.cond1 && triggerLogicAttrs.condGrp1.cond1.op !== 'EXISTS') ?  triggerLogicAttrs.condGrp1.cond1.value : ''}
                            </span>
                          </Col>
                        </Row>

                        <Row className={classes.admin_pages__field_value} style={{display:'flex'}}>
                          <Col md={12} style={{display:'flex', marginLeft:'5px'}}>
                            {(triggerLogicAttrs && triggerLogicAttrs.condGrp1 && triggerLogicAttrs.condGrp1.condOp1) ?
                             andOrOptions.find( item => item.key === triggerLogicAttrs.condGrp1.condOp1).value : ''}
                          </Col>
                        </Row>

                        <Row className={classes.admin_pages__field_value} style={{display:'flex'}}>
                          <Col md={12} style={{display:'flex'}}>
                            <span>
                              {(triggerLogicAttrs && triggerLogicAttrs.condGrp1 && triggerLogicAttrs.condGrp1.cond2) ?  triggerLogicAttrs.condGrp1.cond2.dp : ''}
                            </span>
                            <span style={{marginLeft:'10px',marginRight:'10px'}}>
                              {(triggerLogicAttrs && triggerLogicAttrs.condGrp1 && triggerLogicAttrs.condGrp1.cond2 && triggerLogicAttrs.condGrp1.cond2.op) ?
                               opOptions.find( item => item.key === triggerLogicAttrs.condGrp1.cond2.op).value : ''}
                            </span>
                            <span>
                              {(triggerLogicAttrs && triggerLogicAttrs.condGrp1 && triggerLogicAttrs.condGrp1.cond2) ? triggerLogicAttrs.condGrp1.cond2.value : ''}
                            </span>
                          </Col>
                        </Row>

                      </div>

                      { triggerLogicAttrs.condGrp2 && (!triggerLogicAttrs.useOccCnt || (triggerLogicAttrs.useOccCnt !== true)) ?
                        <>
                          <div style={{padding:'5px', marginLeft:'12px' }}>
                            {'[ ' + t("custom:I18N_LogicalOp_AND") + ' ]'}
                          </div>

                          <div style={{marginLeft: '10px', marginTop: '0px', padding:'10px', border:'1px solid #AAA', borderRadius:'5px' }}>

                            <Row className={classes.admin_pages__field_value} style={{display:'flex'}}>
                              <Col md={12} style={{display:'flex'}}>
                                <span>
                                  {(triggerLogicAttrs && triggerLogicAttrs.condGrp2 && triggerLogicAttrs.condGrp2.cond3) ?  triggerLogicAttrs.condGrp2.cond3.dp : ''}
                                </span>
                                <span style={{marginLeft:'10px',marginRight:'10px'}}>
                                  {(triggerLogicAttrs && triggerLogicAttrs.condGrp2 && triggerLogicAttrs.condGrp2.cond3 && triggerLogicAttrs.condGrp2.cond3.op) ?
                                   opOptions.find( item => item.key === triggerLogicAttrs.condGrp2.cond3.op).value : ''}
                                </span>
                                <span>
                                  {(triggerLogicAttrs && triggerLogicAttrs.condGrp2 && triggerLogicAttrs.condGrp2.cond3) ?  triggerLogicAttrs.condGrp2.cond3.value : ''}
                                </span>
                              </Col>
                            </Row>

                            <Row className={classes.admin_pages__field_value} style={{display:'flex'}}>
                              <Col md={12} style={{display:'flex', marginLeft:'5px'}}>
                                {(triggerLogicAttrs && triggerLogicAttrs.condGrp2 && triggerLogicAttrs.condGrp2.condOp2) ?
                                 andOrOptions.find( item => item.key === triggerLogicAttrs.condGrp2.condOp2).value : ''}
                              </Col>
                            </Row>

                            <Row className={classes.admin_pages__field_value} style={{display:'flex'}}>
                              <Col md={12} style={{display:'flex'}}>
                                <span>
                                  {(triggerLogicAttrs && triggerLogicAttrs.condGrp2 && triggerLogicAttrs.condGrp2.cond4) ?  triggerLogicAttrs.condGrp2.cond4.dp : ''}
                                </span>
                                <span style={{marginLeft:'10px',marginRight:'10px'}}>
                                  {(triggerLogicAttrs && triggerLogicAttrs.condGrp2 && triggerLogicAttrs.condGrp2.cond4 && triggerLogicAttrs.condGrp2.cond4.op) ?
                                   opOptions.find( item => item.key === triggerLogicAttrs.condGrp2.cond4.op).value : ''}
                                </span>
                                <span>
                                  {(triggerLogicAttrs && triggerLogicAttrs.condGrp2 && triggerLogicAttrs.condGrp2.cond4) ? triggerLogicAttrs.condGrp2.cond4.value : ''}
                                </span>
                              </Col>
                            </Row>

                          </div>
                        </>
                      : null
                      }

                    </>
                    :
                      <span className={classes.admin_pages__field_value} style={{marginTop:'20px'}}>
                        { t("I18N_No_trigger_logic") }
                      </span>
                  }
                </Container>
              }
            </div>
          :
            null
          }


          {/* ----- Associated Datapoint Type List -----*/}

          <div className={classes.admin_pages__page_subtitle} style={{marginTop:'20px'}}>
            <div style={{display:'flex'}}>
              <span>
                {t("I18N_DpType_assoc_with_alarm_rule")}
              </span>
              <span style={{marginLeft:'auto', marginRight:'20px'}}>
                <span  onClick={handleAddAssocDpType} style={{marginLeft:'5px'}} data-tooltip-id="tooltip-add-dptype" data-tooltip-html={t("I18N_TIP_Add_datapoint_type")} >
                  <BiPlus size={18} />
                </span>
                <Tooltip id="tooltip-add-dptype" />
              </span>
            </div>

            <hr className="solid" style={{ margin: '0 0 0 0' }}></hr>

            <div style={{overflow:'auto', maxHeight:'200px', fontSize:'11px', marginTop:'10px'}}>

              <Table hover responsive size="sm">
                <thead style={{color:'#686868', fontSize:'12px', borderBottom:"2px solid #D0D0D0"}}>
                  <tr>
                    <th style={{width:"30%", fontWeight:'400'}}>{t("I18N_Datapoint_type_code")}</th>
                    <th style={{width:"35%", fontWeight:'400'}}>{t("I18N_Description")}</th>
                    <th style={{width:"30%", fontWeight:'400'}}>{t("I18N_Subsystem")}</th>
                    <th style={{width:"5%"}}></th>
                  </tr>
                </thead>
                <tbody>
                  {(assocDpTypeList && assocDpTypeList.length > 0) ? assocDpTypeList.map(renderAssocDpType) : null}
                </tbody>
              </Table>
            </div>
          </div>


          {/* ----- Associated Datapoint List -----*/}

          <div className={classes.admin_pages__page_subtitle} style={{marginTop:'20px'}}>
            <div style={{display:'flex'}}>
              <span>
                {t("I18N_Dp_assoc_with_alarm_rule")}
              </span>
              <span style={{marginLeft:'auto', marginRight:'20px'}}>
                <span  onClick={handleAddAssocDp} style={{marginLeft:'5px'}} data-tooltip-id="tooltip-add-dp" data-tooltip-html={t("I18N_TIP_Add_datapoint")} >
                  <BiPlus size={18} />
                </span>
                <Tooltip id="tooltip-add-dp" />
              </span>
            </div>

            <hr className="solid" style={{ margin: '0 0 0 0' }}></hr>

            <div style={{overflow:'auto', maxHeight:'200px', fontSize:'11px', marginTop:'10px'}}>

              <Table hover responsive size="sm">
                <thead style={{color:'#686868', fontSize:'12px', borderBottom:"2px solid #D0D0D0"}}>
                  <tr>
                    <th style={{width:"30%", fontWeight:'400'}}>{t("I18N_Datapoint_code")}</th>
                    <th style={{width:"35%", fontWeight:'400'}}>{t("I18N_Description")}</th>
                    <th style={{width:"30%", fontWeight:'400'}}></th>
                    <th style={{width:"5%"}}></th>
                  </tr>
                </thead>
                <tbody>
                  {(assocDpList && assocDpList.length > 0) ? assocDpList.map(renderAssocDp) : null}
                </tbody>
              </Table>
            </div>
          </div>


          {/* ----- Action list -----*/}

          { configInfo.uiConfig.visibleFields.ALARMRULE_Actions ?
          <div className={classes.admin_pages__page_subtitle} style={{marginTop:'30px'}}>
            <div style={{display:'flex'}}>
              <span>
                {t("I18N_Action_assoc_with_alarm_rule")}
              </span>
              <span style={{marginLeft:'auto', marginRight:'20px'}}>
{/*
                <OverlayTrigger overlay={<Tooltip id="tooltip-new_notifType" style={{fontSize:'11px'}}>{t("I18N_TIP_Add_action")}</Tooltip>}>
                  <span onClick={handleAddActions} style={{ marginLeft: '0px', marginRight: '0px', marginTop: '3px', cursor: 'pointer', color: 'rgb(100,100,100)' }}>
                    <BiPlus size={18} />
                  </span>
                </OverlayTrigger>
*/}
                <span onClick={handleAddActions} style={{marginLeft:'5px'}} data-tooltip-id="tooltip-add-action" data-tooltip-html={t("I18N_TIP_actions")} >
                  <BiPlus size={18} />
                </span>
                <Tooltip id="tooltip-add-action" />
              </span>
            </div>

            <hr className="solid" style={{ margin: '0 0 0 0' }}></hr>

            <div style={{overflow:'auto', fontSize:'11px', marginTop:'10px'}}>

              <Table hover responsive size="sm">
                <thead style={{color:'#686868', fontSize:'12px', borderBottom:"2px solid #D0D0D0"}}>
                  <tr>
                    <th style={{width:"30%", fontWeight:'400'}}>{t("I18N_Action_name")}</th>
                    <th style={{width:"35%", fontWeight:'400'}}>{t("I18N_Description")}</th>
                    <th style={{width:"30%", fontWeight:'400'}}>{t("I18N_Type")}</th>
                    <th style={{width:"5%"}}></th>
                  </tr>
                </thead>
                <tbody>
                  {(actionList && actionList.length > 0) ? actionList.map(renderAction) : null}
                </tbody>
              </Table>
            </div>
          </div>
          : null
          }

        </div>

        <hr className="solid" style={{ marginTop: '30px' }}></hr>

        <div className={classes.admin_pages__page_subtitle} >
          <Form.Group as={Row} className="mb-2 mt-3">
            <div style={{ display: "flex" }}>
              <Button size="sm" variant="outline-secondary" className="mb-3"
                style={{ marginLeft:'0px', fontSize:'12px', fontWeight:'300' }}
                onClick={handleClose}>
                {t("I18N_Close")}
              </Button>
              <span className={classes.admin_pages__field_label} style={{ color: 'rgba(200,0,0)', marginLeft: '20px' }}>
                {errMsg}
              </span>
            </div>
          </Form.Group>
        </div>


        <Modal show={showAddActionDialog} onHide={handleAddActionsClose} centered >
          <Modal.Body>

            <div className={classes.admin_pages__page_subtitle} style={{marginTop:'0px'}}>
              <div display='flex'>
                <span>
                  {t("I18N_Actions")}
                </span>
              </div>

              <hr className="solid" style={{ margin: '0 0 10px 0' }}></hr>
            </div>

            <div style={{overflow:'auto', fontSize:'11px', marginTop:'10px'}}>
              <Table hover responsive size="sm">
                <thead style={{color:'#686868', fontSize:'12px', borderBottom:"2px solid #D0D0D0"}}>
                  <tr>
                    <th style={{width:"5%"}}></th>
                    <th style={{width:"35%", fontWeight:'400'}}>{t("I18N_Action_name")}</th>
                    <th style={{width:"30%", fontWeight:'400'}}>{t("I18N_Description")}</th>
                    <th style={{width:"30%", fontWeight:'400'}}>{t("I18N_Type")}</th>
                  </tr>
                </thead>
                <tbody>
                  {unassignedActionList ? unassignedActionList.map(renderAddActions) : null}
                </tbody>
              </Table>
            </div>

            <div display='flex' style={{ marginTop: '15px' }}>
              <Button size="tiny" variant="outline-secondary" className="mb-3"
                style={{ float: 'left' }}
                onClick={handleAddActionsClose}>
                {t("I18N_Cancel")}
              </Button>
              <Button size="tiny" variant="outline-secondary" className="mb-3"
                style={{ marginLeft: '15px' }}
                onClick={handleAddActionsSubmit}>
                {t("I18N_Add_actions")}
              </Button>
              <span className={classes.admin_pages__field_label} style={{ marginLeft: '30px', color: 'rgba(200,0,0)', verticalAlign: 'top' }}>
                {addActionErrMsg}
              </span>
            </div>
          </Modal.Body>
        </Modal>


        {/* --- Dialog to pick datapoint type to join the associated list --- */}

        <Modal show={showDpTypeSelectDialog} onHide={handleDpTypeSelectCancel} centered >
          <Modal.Body>
            <div className={classes.admin_pages__page_subtitle} style={{marginTop:'0px'}}>
              <span>
                {t("I18N_DpType_picker")}
              </span>

              <hr className="solid" style={{ margin: '0 0 10px 0' }}></hr>

                <Row className={classes.admin_pages__field_label}>
                  <Col>{t("I18N_Datapoint_type_code")}: *</Col>
                </Row>
                <Row className={classes.admin_pages__field_value}>
                  <Col>
                    <Form onSubmit={handleDpTypeSearch}>
                      <Form.Control style={{ fontSize: '12px', height:'22px' }} type="text" name="dpTypeSearchTerm" value={dpTypeSearchTerm}
                                    onChange={(e) => onDpTypeSearchInputChange(e)} placeholder={''} />
                    </Form>
                  </Col>
                  <Col>
                    <span onClick={handleDpTypeSearch} style={{ marginLeft:'10px', cursor: 'pointer', color: 'rgb(100,100,100)' }}>
                      <BiSearch size={14} />
                    </span>
                  </Col>
                </Row>

                <hr className="solid" style={{ margin: '10px 0 10px 0' }}></hr>

                <div style={{overflowY:'scroll', fontSize:'11px', marginTop:'10px', maxHeight:'600px'}}>
                  <Table hover responsive size="sm">
                    <thead style={{color:'#686868', fontSize:'12px', borderBottom:"2px solid #D0D0D0"}}>
                      <tr>
                        <th style={{fontWeight:'400'}}>{t("I18N_Datapoint_type_code")}</th>
                        <th style={{fontWeight:'400'}}>{t("I18N_Description")}</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      {(dpTypeList && dpTypeList.length > 0) ? dpTypeList.map(item => renderDpType(item, 'ASSOC_SELECT')) : null}
                    </tbody>
                  </Table>
                </div>

                <Row>
                  <span className={classes.admin_pages__field_label} style={{marginTop:'5px', color:'rgba(200,0,0)', verticalAlign:'top'}}>
                    {errMsg_DpTypeSelect}
                  </span>
                </Row>
                <Row>
                  <div display='flex' style={{marginTop:'15px'}}>
                    <Button size="tiny" variant="outline-secondary" className="mb-3"
                      style={{ float: 'left' }}
                      onClick={handleDpTypeSelectCancel}>
                      {t("I18N_Close")}
                    </Button>
                  </div>
                </Row>

            </div>
          </Modal.Body>
        </Modal>


        {/* --- Dialog to pick datapoint type from the associated list to define formula --- */}

        <Modal show={showFormulaDpTypeSelDialog} onHide={handleAssocDpTypeSelCancel} centered >
          <Modal.Body>
            <div className={classes.admin_pages__page_subtitle} style={{marginTop:'0px'}}>
              <span>
                {t("I18N_Assoc_dp_types")}
              </span>

              <hr className="solid" style={{ margin: '0 0 10px 0' }}></hr>

                <div style={{overflowY:'scroll', fontSize:'11px', marginTop:'10px', maxHeight:'600px'}}>
                  <Table hover responsive size="sm">
                    <thead style={{color:'#686868', fontSize:'12px', borderBottom:"2px solid #D0D0D0"}}>
                      <tr>
                        <th style={{fontWeight:'400'}}>{t("I18N_Datapoint_type_code")}</th>
                        <th style={{fontWeight:'400'}}>{t("I18N_Description")}</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      {(assocDpTypeList && assocDpTypeList.length > 0) ? assocDpTypeList.map(item => renderDpType(item, 'FORMULA_SELECT')) : null}
                    </tbody>
                  </Table>
                </div>

                <Row>
                  <span className={classes.admin_pages__field_label} style={{marginTop:'5px', color:'rgba(200,0,0)', verticalAlign:'top'}}>
                    {errMsg_FormulaDpTypeSel}
                  </span>
                </Row>
                <Row>
                  <div display='flex' style={{marginTop:'15px'}}>
                    <Button size="tiny" variant="outline-secondary" className="mb-3"
                      style={{ float: 'left' }}
                      onClick={handleAssocDpTypeSelCancel}>
                      {t("I18N_Close")}
                    </Button>
                  </div>
                </Row>

            </div>
          </Modal.Body>
        </Modal>


        {/* --- Dialog to pick datapoint to join the associated list --- */}

        <Modal show={showDpSelectDialog} onHide={handleDatapointSelectCancel} centered >
          <Modal.Body>
            <div className={classes.admin_pages__page_subtitle} style={{marginTop:'0px'}}>
              <span>
                {t("I18N_Datapoint_picker")}
              </span>

              <hr className="solid" style={{ margin: '0 0 10px 0' }}></hr>

                <Row className={classes.admin_pages__field_label}>
                  <Col>{t("I18N_Datapoint_code")}: *</Col>
                </Row>
                <Row className={classes.admin_pages__field_value}>
                  <Col>
                    <Form onSubmit={handleDatapointSearch}>
                      <Form.Control style={{ fontSize: '12px', height:'22px' }} type="text" name="dpSearchTerm" value={dpSearchTerm}
                                    onChange={(e) => onDatapointSearchInputChange(e)} placeholder={''} />
                    </Form>
                  </Col>
                  <Col>
                    <span onClick={handleDatapointSearch} style={{ marginLeft:'10px', cursor: 'pointer', color: 'rgb(100,100,100)' }}>
                      <BiSearch size={14} />
                    </span>
                  </Col>
                </Row>

                <hr className="solid" style={{ margin: '10px 0 10px 0' }}></hr>

                <div style={{overflowY:'scroll', fontSize:'11px', marginTop:'10px', maxHeight:'600px'}}>
                  <Table hover responsive size="sm">
                    <thead style={{color:'#686868', fontSize:'12px', borderBottom:"2px solid #D0D0D0"}}>
                      <tr>
                        <th style={{fontWeight:'400'}}>{t("I18N_Datapoint_code")}</th>
                        <th style={{fontWeight:'400'}}>{t("I18N_Description")}</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      {(dpList && dpList.length > 0) ? dpList.map(item => renderDatapoint(item, 'ASSOC_SELECT')) : null}
                    </tbody>
                  </Table>
                </div>

                <Row>
                  <span className={classes.admin_pages__field_label} style={{marginTop:'5px', color:'rgba(200,0,0)', verticalAlign:'top'}}>
                    {errMsg_DpSelect}
                  </span>
                </Row>
                <Row>
                  <div display='flex' style={{marginTop:'15px'}}>
                    <Button size="tiny" variant="outline-secondary" className="mb-3"
                      style={{ float: 'left' }}
                      onClick={handleDatapointSelectCancel}>
                      {t("I18N_Close")}
                    </Button>
                  </div>
                </Row>

            </div>
          </Modal.Body>
        </Modal>


        {/* --- Dialog to pick datapoint from the associated list to define formula --- */}

        <Modal show={showFormulaDpSelDialog} onHide={handleFormulaDpSelCancel} centered >
          <Modal.Body>
            <div className={classes.admin_pages__page_subtitle} style={{marginTop:'0px'}}>
              <span>
                {t("I18N_Assoc_dps")}
              </span>

              <hr className="solid" style={{ margin: '0 0 10px 0' }}></hr>

                <div style={{overflowY:'scroll', fontSize:'11px', marginTop:'10px', maxHeight:'600px'}}>
                  <Table hover responsive size="sm">
                    <thead style={{color:'#686868', fontSize:'12px', borderBottom:"2px solid #D0D0D0"}}>
                      <tr>
                        <th style={{fontWeight:'400'}}>{t("I18N_Datapoint_code")}</th>
                        <th style={{fontWeight:'400'}}>{t("I18N_Description")}</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      {(assocDpList && assocDpList.length > 0) ? assocDpList.map(item => renderDatapoint(item, 'FORMULA_SELECT')) : null}
                    </tbody>
                  </Table>
                </div>

                <Row>
                  <span className={classes.admin_pages__field_label} style={{marginTop:'5px', color:'rgba(200,0,0)', verticalAlign:'top'}}>
                    {errMsg_FormulaDpSel}
                  </span>
                </Row>
                <Row>
                  <div display='flex' style={{marginTop:'15px'}}>
                    <Button size="tiny" variant="outline-secondary" className="mb-3"
                      style={{ float: 'left' }}
                      onClick={handleFormulaDpSelCancel}>
                      {t("I18N_Close")}
                    </Button>
                  </div>
                </Row>

            </div>
          </Modal.Body>
        </Modal>


        <SoundPickerDialog
          show={showSoundPickerDialog}
          handleObjSelect={handleSoundSelect}
          onClose={handleSoundPickerClose}
        />

        <DeleteConfirmDialog
          title={t("I18N_Alm_rule_change_data_scope")}
          show={showDeleteConfirmDialog}
          targetName={''}
          errMsgDeleteConfirm={errMsgDeleteConfirm}
          onCancel={handleObjDeleteCancel}
          onSubmit={handleObjDeleteSubmit}
        />

      </Card>
    </>
  );
}

export default AlarmRuleAdminDetailsView;
